(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bw-announcement-marquee"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bw-marquee')) {
    class BWMarquee extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.bw-marquee__track');
        this.group = this.querySelector('[data-group]');
        if (!this.track || !this.group) return;

        this.speed = Math.min(10, Math.max(1, parseInt(this.dataset.speed, 10) || 4));
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.lastWidth = 0;

        this.build();
        if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => this.build(true));

        this.observer = new ResizeObserver(() => {
          const w = this.getBoundingClientRect().width;
          if (Math.abs(w - this.lastWidth) < 2) return;
          cancelAnimationFrame(this.raf);
          this.raf = requestAnimationFrame(() => this.build());
        });
        this.observer.observe(this);

        this.onSelect = (e) => { if (this.inSection(e)) this.classList.add('is-paused'); };
        this.onDeselect = (e) => { if (this.inSection(e)) this.classList.remove('is-paused'); };
        document.addEventListener('shopify:block:select', this.onSelect);
        document.addEventListener('shopify:block:deselect', this.onDeselect);
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        document.removeEventListener('shopify:block:select', this.onSelect);
        document.removeEventListener('shopify:block:deselect', this.onDeselect);
      }

      inSection(e) {
        const section = this.closest('.shopify-section');
        return section && e.target && section.contains(e.target);
      }

      build(force) {
        const viewportWidth = this.getBoundingClientRect().width;
        if (!force && viewportWidth === this.lastWidth && this.classList.contains('is-ready')) return;
        this.lastWidth = viewportWidth;

        this.track.querySelectorAll('[data-clone]').forEach((node) => node.remove());
        if (this.reduced) return;

        const groupWidth = this.group.getBoundingClientRect().width;
        if (!groupWidth) return;

        const copies = Math.ceil(viewportWidth / groupWidth) + 1;
        for (let i = 0; i < copies; i++) {
          const clone = this.group.cloneNode(true);
          clone.removeAttribute('data-group');
          clone.setAttribute('data-clone', '');
          clone.setAttribute('aria-hidden', 'true');
          clone.querySelectorAll('*').forEach((el) => {
            [...el.attributes].forEach((attr) => {
              if (attr.name.startsWith('data-shopify')) el.removeAttribute(attr.name);
            });
          });
          clone.querySelectorAll('a').forEach((a) => a.setAttribute('tabindex', '-1'));
          this.track.appendChild(clone);
        }

        // Speed 1 = 35px/s, speed 10 = 170px/s — same feel regardless of message count
        const pxPerSecond = 20 + this.speed * 15;
        this.style.setProperty('--bw-shift', groupWidth + 'px');
        this.style.setProperty('--bw-duration', (groupWidth / pxPerSecond).toFixed(2) + 's');
        this.classList.add('is-ready');
      }
    }
    customElements.define('bw-marquee', BWMarquee);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bw-brand-story"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('bw-story')) return;

    class BWStory extends HTMLElement {
      connectedCallback() {
        var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        var editing = window.Shopify && window.Shopify.designMode;

        if (this.dataset.reveal === 'true' && !reduce && !editing && 'IntersectionObserver' in window) {
          this.classList.add('js-reveal');
          this.revealObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              this.classList.add('is-revealed');
              this.revealObserver.disconnect();
            });
          }, { threshold: 0.2, rootMargin: '0px 0px -8% 0px' });
          this.revealObserver.observe(this);
        }

        this.video = this.querySelector('video.bws__video:not(.bws__video--controls)');
        this.pauseBtn = this.querySelector('[data-pause]');
        if (this.video) {
          this.video.muted = true;
          this.video.setAttribute('playsinline', '');
          this.userPaused = reduce;
          if (reduce) this.setPaused(true);

          if (this.pauseBtn) {
            this.pauseBtn.addEventListener('click', () => {
              this.userPaused = !this.video.paused ? true : false;
              this.setPaused(this.userPaused);
            });
          }

          if ('IntersectionObserver' in window) {
            this.videoObserver = new IntersectionObserver((entries) => {
              entries.forEach((entry) => {
                if (this.userPaused) return;
                if (entry.isIntersecting) this.video.play().catch(() => {});
                else this.video.pause();
              });
            }, { threshold: 0.1 });
            this.videoObserver.observe(this.video);
          }
        }
      }

      setPaused(paused) {
        if (!this.video) return;
        if (paused) this.video.pause();
        else this.video.play().catch(() => {});
        if (this.pauseBtn) {
          this.pauseBtn.classList.toggle('is-paused', paused);
          this.pauseBtn.setAttribute('aria-label', paused ? 'Play video' : 'Pause video');
        }
      }

      disconnectedCallback() {
        if (this.revealObserver) this.revealObserver.disconnect();
        if (this.videoObserver) this.videoObserver.disconnect();
      }
    }

    customElements.define('bw-story', BWStory);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bw-collection-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('bw-collection-grid')) return;

    var BW = (window.BWStore = window.BWStore || {});

    /* ---------- Favourites (saved in the shopper's browser) ---------- */
    if (!BW.wishlist) {
      var KEY = 'bw-wishlist';
      var read = function () {
        try {
          var v = JSON.parse(localStorage.getItem(KEY) || '[]');
          return Array.isArray(v) ? v : [];
        } catch (e) {
          return [];
        }
      };
      BW.wishlist = {
        get: read,
        has: function (h) { return read().indexOf(h) > -1; },
        toggle: function (h) {
          var list = read();
          var i = list.indexOf(h);
          if (i > -1) list.splice(i, 1);
          else list.unshift(h);
          try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
          document.dispatchEvent(new CustomEvent('bw:wishlist:change', { detail: { list: list } }));
          return i === -1;
        },
        sync: function (root) {
          var list = read();
          (root || document).querySelectorAll('[data-wishlist]').forEach(function (btn) {
            var on = list.indexOf(btn.dataset.wishlist) > -1;
            btn.classList.toggle('is-active', on);
            btn.setAttribute('aria-pressed', on ? 'true' : 'false');
          });
        }
      };
      document.addEventListener('bw:wishlist:change', function () { BW.wishlist.sync(); });
      window.addEventListener('storage', function (e) { if (e.key === KEY) BW.wishlist.sync(); });
    }

    /* ---------- Toast ---------- */
    if (!BW.toast) {
      BW.toast = function (message, colors) {
        var el = document.querySelector('.bw-toast');
        if (!el) {
          el = document.createElement('div');
          el.className = 'bw-toast';
          el.setAttribute('role', 'status');
          el.setAttribute('aria-live', 'polite');
          document.body.appendChild(el);
        }
        if (colors) {
          el.style.background = colors.bg;
          el.style.color = colors.fg;
        }
        el.textContent = message;
        el.classList.add('is-visible');
        clearTimeout(el._timer);
        el._timer = setTimeout(function () { el.classList.remove('is-visible'); }, 2600);
      };
    }

    var esc = function (str) {
      return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    };
    var sized = function (src, w) {
      if (!src) return '';
      return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
    };
    var ICON_HEART =
      '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false"><path d="M12 20.3s-7.4-4.5-9.2-9.1C1.5 7.9 3.6 4.6 7 4.6c2 0 3.4 1.1 5 3 1.6-1.9 3-3 5-3 3.4 0 5.5 3.3 4.2 6.6-1.8 4.6-9.2 9.1-9.2 9.1z" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"/></svg>';

    class BWCollectionGrid extends HTMLElement {
      connectedCallback() {
        this.initCards();
        this.initGrid();
      }

      /* ======================= Filters, sorting and pagination ======================= */
      initGrid() {
        this.sectionId = this.dataset.sectionId;
        this.cacheMap = new Map();
        this.applyView();
        this.syncPrice();

        this.addEventListener('click', (e) => {
          var link = e.target.closest('[data-filter-url]');
          if (link && link.href) {
            e.preventDefault();
            this.navigate(link.href, { scroll: link.hasAttribute('data-scroll') });
            return;
          }
          if (e.target.closest('[data-open-filters]')) { this.openFilters(); return; }
          if (e.target.closest('[data-close-filters]')) { this.closeFilters(); return; }
          var view = e.target.closest('[data-view]');
          if (view) { this.setView(view.dataset.scope, view.dataset.view); return; }
          var more = e.target.closest('[data-load-more]');
          if (more) { this.loadMore(more); return; }
        });

        this.addEventListener('input', (e) => {
          if (e.target.matches('[data-range]')) this.onRange(e.target);
        });

        this.addEventListener('change', (e) => {
          var t = e.target;
          if (t.matches('[data-sort]')) { this.apply(); return; }
          if (t.matches('[data-range]')) { this.apply(); return; }
          if (t.matches('[data-price-input]')) {
            clearTimeout(this.priceTimer);
            this.priceTimer = setTimeout(() => { this.syncPrice(); this.apply(); }, 400);
            return;
          }
          if (t.closest('[data-filter-form]') && t.type === 'checkbox') this.apply();
        });

        this.addEventListener('submit', (e) => {
          if (e.target.matches('[data-filter-form]')) { e.preventDefault(); this.apply(); }
        });

        this.onKey = (e) => { if (e.key === 'Escape' && this.classList.contains('filters-open')) this.closeFilters(); };
        document.addEventListener('keydown', this.onKey);

        this.onPop = () => this.navigate(window.location.href, { push: false });
        window.addEventListener('popstate', this.onPop);

        this.setupInfinite();
      }

      buildUrl() {
        var params = new URLSearchParams();
        var form = this.querySelector('[data-filter-form]');
        if (form) {
          new FormData(form).forEach((value, key) => {
            if (String(value).trim() !== '') params.append(key, value);
          });
        }
        var sort = this.querySelector('[data-sort]');
        if (sort && sort.value) params.set('sort_by', sort.value);
        var qs = params.toString();
        return window.location.pathname + (qs ? '?' + qs : '');
      }

      apply() {
        this.navigate(this.buildUrl(), { scroll: false });
      }

      sectionUrl(url) {
        var u = new URL(url, window.location.origin);
        u.searchParams.set('section_id', this.sectionId);
        return u.toString();
      }

      async fetchSection(url) {
        var key = this.sectionUrl(url);
        if (this.cacheMap.has(key)) return this.cacheMap.get(key);
        var res = await fetch(key);
        if (!res.ok) throw new Error('Request failed');
        var html = await res.text();
        var doc = new DOMParser().parseFromString(html, 'text/html');
        this.cacheMap.set(key, doc);
        return doc;
      }

      async navigate(url, opts) {
        opts = opts || {};
        var push = opts.push !== false;
        this.classList.add('is-loading');
        try {
          var doc = await this.fetchSection(url);
          var fresh = doc.querySelector('bw-collection-grid');
          if (!fresh) throw new Error('Missing section');

          this.swap(fresh, '[data-results]');
          this.swapFacets(fresh);
          this.swap(fresh, '[data-count]');
          this.swap(fresh, '[data-apply-label]');
          this.swapAttr(fresh, '[data-active-count]');
          var freshSort = fresh.querySelector('[data-sort]');
          var sort = this.querySelector('[data-sort]');
          if (freshSort && sort) sort.value = freshSort.value;

          var clean = new URL(url, window.location.origin);
          clean.searchParams.delete('section_id');
          if (push) history.pushState({ bwGrid: true }, '', clean.pathname + clean.search);

          var grid = this.querySelector('[data-products]');
          if (grid) {
            grid.classList.remove('is-entering');
            void grid.offsetWidth;
            grid.classList.add('is-entering');
          }
          BW.wishlist.sync(this);
          this.syncPrice();
          this.setupInfinite();

          if (opts.scroll) {
            var top = this.getBoundingClientRect().top + window.scrollY - 20;
            window.scrollTo({ top: top, behavior: 'smooth' });
          }
        } catch (err) {
          window.location.href = url;
        } finally {
          this.classList.remove('is-loading');
        }
      }

      swap(fresh, selector) {
        var next = fresh.querySelector(selector);
        var current = this.querySelector(selector);
        if (next && current) current.innerHTML = next.innerHTML;
      }

      swapAttr(fresh, selector) {
        var next = fresh.querySelector(selector);
        var current = this.querySelector(selector);
        if (!next || !current) return;
        current.textContent = next.textContent;
        current.hidden = next.hidden;
      }

      swapFacets(fresh) {
        var current = this.querySelector('[data-facets]');
        var next = fresh.querySelector('[data-facets]');
        if (!current || !next) return;
        var open = {};
        current.querySelectorAll('[data-facet]').forEach((d) => { open[d.dataset.facet] = d.open; });
        var scroll = current.closest('.bwg__form') ? current.closest('.bwg__form').scrollTop : 0;
        var focusedName = document.activeElement && document.activeElement.name;
        var focusedValue = document.activeElement && document.activeElement.value;
        current.innerHTML = next.innerHTML;
        current.querySelectorAll('[data-facet]').forEach((d) => {
          if (d.dataset.facet in open) d.open = open[d.dataset.facet];
        });
        if (current.closest('.bwg__form')) current.closest('.bwg__form').scrollTop = scroll;
        if (focusedName) {
          var el = Array.from(current.querySelectorAll('input')).find((i) => i.name === focusedName && (i.type !== 'checkbox' || i.value === focusedValue));
          if (el) el.focus({ preventScroll: true });
        }
      }

      /* ---------- Drawer ---------- */
      openFilters() {
        this.classList.add('filters-open');
        document.documentElement.classList.add('bwg-lock');
        var toggle = this.querySelector('[data-open-filters]');
        if (toggle) toggle.setAttribute('aria-expanded', 'true');
        var panel = this.querySelector('[data-filters]');
        var close = panel && panel.querySelector('.bwg__filters-close');
        if (close) setTimeout(() => close.focus({ preventScroll: true }), 50);
      }

      closeFilters() {
        this.classList.remove('filters-open');
        document.documentElement.classList.remove('bwg-lock');
        var toggle = this.querySelector('[data-open-filters]');
        if (toggle) { toggle.setAttribute('aria-expanded', 'false'); }
      }

      /* ---------- Price range ---------- */
      onRange(input) {
        var box = input.closest('[data-price]');
        if (!box) return;
        var minR = box.querySelector('[data-range="min"]');
        var maxR = box.querySelector('[data-range="max"]');
        var gap = 1;
        if (input === minR && Number(minR.value) > Number(maxR.value) - gap) minR.value = Number(maxR.value) - gap;
        if (input === maxR && Number(maxR.value) < Number(minR.value) + gap) maxR.value = Number(minR.value) + gap;
        var max = Number(box.dataset.max) || 0;
        var minInput = box.querySelector('[data-price-input="min"]');
        var maxInput = box.querySelector('[data-price-input="max"]');
        minInput.value = Number(minR.value) > 0 ? minR.value : '';
        maxInput.value = Number(maxR.value) < max ? maxR.value : '';
        this.paintRange(box);
      }

      syncPrice() {
        this.querySelectorAll('[data-price]').forEach((box) => {
          var max = Number(box.dataset.max) || 0;
          var minInput = box.querySelector('[data-price-input="min"]');
          var maxInput = box.querySelector('[data-price-input="max"]');
          var minR = box.querySelector('[data-range="min"]');
          var maxR = box.querySelector('[data-range="max"]');
          if (!minR || !maxR) return;
          var lo = minInput.value === '' ? 0 : Math.max(0, Math.min(max, Number(minInput.value)));
          var hi = maxInput.value === '' ? max : Math.max(0, Math.min(max, Number(maxInput.value)));
          if (lo > hi) { var tmp = lo; lo = hi; hi = tmp; }
          minR.value = lo;
          maxR.value = hi;
          this.paintRange(box);
        });
      }

      paintRange(box) {
        var max = Number(box.dataset.max) || 1;
        var fill = box.querySelector('[data-price-fill]');
        var lo = Number(box.querySelector('[data-range="min"]').value);
        var hi = Number(box.querySelector('[data-range="max"]').value);
        if (fill) {
          fill.style.left = (lo / max) * 100 + '%';
          fill.style.right = (100 - (hi / max) * 100) + '%';
        }
      }

      /* ---------- Shopper view switcher ---------- */
      applyView() {
        var saved = {};
        try { saved = JSON.parse(localStorage.getItem('bw-grid-view') || '{}'); } catch (e) {}
        if (saved.desktop) this.setView('desktop', saved.desktop, true);
        if (saved.mobile) this.setView('mobile', saved.mobile, true);
      }

      setView(scope, cols, silent) {
        var prop = scope === 'mobile' ? '--g-cols-user-m' : '--g-cols-user-d';
        this.style.setProperty(prop, cols);
        this.querySelectorAll('[data-view][data-scope="' + scope + '"]').forEach((b) => {
          b.setAttribute('aria-pressed', b.dataset.view === String(cols) ? 'true' : 'false');
        });
        if (silent) return;
        var saved = {};
        try { saved = JSON.parse(localStorage.getItem('bw-grid-view') || '{}'); } catch (e) {}
        saved[scope] = String(cols);
        try { localStorage.setItem('bw-grid-view', JSON.stringify(saved)); } catch (e) {}
      }

      /* ---------- Load more and infinite scroll ---------- */
      async loadMore(btn) {
        if (this.loadingMore || !btn || !btn.dataset.next) return;
        this.loadingMore = true;
        btn.classList.add('is-loading');
        try {
          var doc = await this.fetchSection(btn.dataset.next);
          var fresh = doc.querySelector('bw-collection-grid');
          var grid = this.querySelector('[data-products]');
          var nextGrid = fresh && fresh.querySelector('[data-products]');
          if (!grid || !nextGrid) throw new Error('Missing grid');
          Array.from(nextGrid.children).forEach((card, i) => {
            card.classList.add('is-new');
            card.style.setProperty('--i', Math.min(i, 7));
            grid.appendChild(card);
          });
          var more = this.querySelector('[data-more]');
          var nextMore = fresh.querySelector('[data-more]');
          if (more && nextMore) more.innerHTML = nextMore.innerHTML;
          else if (more) more.remove();
          BW.wishlist.sync(this);
          this.setupInfinite();
        } catch (err) {
          window.location.href = btn.dataset.next;
        } finally {
          this.loadingMore = false;
          btn.classList.remove('is-loading');
        }
      }

      setupInfinite() {
        if (this.dataset.pagination !== 'infinite' || !('IntersectionObserver' in window)) return;
        if (this.moreObserver) this.moreObserver.disconnect();
        var btn = this.querySelector('[data-load-more]');
        if (!btn) return;
        this.moreObserver = new IntersectionObserver((entries) => {
          if (entries[0].isIntersecting) this.loadMore(this.querySelector('[data-load-more]'));
        }, { rootMargin: '600px 0px' });
        this.moreObserver.observe(btn);
      }

      initCards() {
        this.moneyFormat = this.dataset.moneyFormat || '';
        this.cartAddUrl = this.dataset.cartAddUrl || '/cart/add.js';
        this.rootUrl = (this.dataset.rootUrl || '/').replace(/\/$/, '');
        this.showVendor = this.dataset.showVendor === 'true';
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.panels = Array.from(this.querySelectorAll('.bwg-fc__panel'));
        this.indicator = this.querySelector('.bwg-fc__indicator');
        this.viewAll = Array.from(this.querySelectorAll('[data-view-all]'));
        this.nav = this.querySelector('[data-nav]');
        this.dialog = this.querySelector('.bwg-qv');
        this.cache = new Map();

        this.addEventListener('click', this.handleClick.bind(this));
        this.addEventListener('keydown', this.handleKeydown.bind(this));
        this.addEventListener('change', this.handleChange.bind(this));

        this.querySelectorAll('.bwg-fc__grid--carousel').forEach((track) => {
          track.addEventListener('scroll', () => this.refreshArrows(), { passive: true });
        });

        if (window.ResizeObserver) {
          this.ro = new ResizeObserver(() => {
            this.moveIndicator();
            this.refreshArrows();
          });
          this.ro.observe(this);
        }
        if (document.fonts && document.fonts.ready) {
          document.fonts.ready.then(() => { this.moveIndicator(); this.refreshArrows(); });
        }
        this.moveIndicator();
        this.refreshArrows();

        if (this.dialog) {
          this.dialog.addEventListener('click', (e) => { if (e.target === this.dialog) this.closeQuickView(); });
          this.dialog.addEventListener('close', () => document.documentElement.classList.remove('bw-lock'));
        }

        BW.wishlist.sync(this);

        this.onDocClick = (e) => {
          if (!e.target.closest || !e.target.closest('.bwg-card__picker, [data-pick]')) this.closePickers();
        };
        this.onDocKey = (e) => { if (e.key === 'Escape') this.closePickers(true); };
        document.addEventListener('click', this.onDocClick);
        document.addEventListener('keydown', this.onDocKey);

        this.onBlockSelect = (e) => {
          if (!this.contains(e.target)) return;
          var tab = e.target.closest && e.target.closest('[role="tab"]');
          if (tab) this.activateTab(tab);
        };
        document.addEventListener('shopify:block:select', this.onBlockSelect);
      }

      disconnectedCallback() {
        if (this.onKey) document.removeEventListener('keydown', this.onKey);
        if (this.onPop) window.removeEventListener('popstate', this.onPop);
        if (this.moreObserver) this.moreObserver.disconnect();
        document.documentElement.classList.remove('bwg-lock');
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
        document.removeEventListener('click', this.onDocClick);
        document.removeEventListener('keydown', this.onDocKey);
        if (this.ro) this.ro.disconnect();
        document.documentElement.classList.remove('bw-lock');
      }

      /* ---------- Events ---------- */
      handleClick(e) {
        var t = e.target;

        var tab = t.closest('[role="tab"]');
        if (tab) { this.activateTab(tab); return; }

        var wish = t.closest('[data-wishlist]');
        if (wish) {
          e.preventDefault();
          var added = BW.wishlist.toggle(wish.dataset.wishlist);
          this.pop(wish);
          this.toast(added ? 'Saved to favourites' : 'Removed from favourites');
          return;
        }

        var pick = t.closest('[data-pick]');
        if (pick) {
          e.preventDefault();
          var card = pick.closest('.bwg-card');
          var open = card.classList.contains('is-picking');
          this.closePickers();
          if (!open) this.openPicker(card);
          return;
        }

        if (t.closest('[data-pick-close]')) { e.preventDefault(); this.closePickers(true); return; }

        var qv = t.closest('[data-quick-view]');
        if (qv) { e.preventDefault(); this.openQuickView(qv.dataset.quickView); return; }

        var add = t.closest('[data-add]');
        if (add) {
          e.preventDefault();
          if (add.disabled || !add.dataset.add) return;
          var form = add.closest('[data-qv-form]');
          var qtyInput = form && form.querySelector('[data-qty]');
          var qty = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
          this.addToCart(add.dataset.add, qty, add);
          return;
        }

        var arrow = t.closest('[data-arrow]');
        if (arrow) {
          var track = this.activeTrack();
          if (!track) return;
          var cardEl = track.querySelector('.bwg-card');
          var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
          var step = cardEl ? cardEl.getBoundingClientRect().width + gap : track.clientWidth;
          track.scrollBy({ left: arrow.dataset.arrow === 'next' ? step : -step, behavior: 'smooth' });
          return;
        }

        var thumb = t.closest('[data-thumb]');
        if (thumb) { this.setMainImage(thumb.dataset.thumb); return; }

        var opt = t.closest('[data-option-index]');
        if (opt) { this.selectOption(Number(opt.dataset.optionIndex), opt.dataset.value); return; }

        var stepBtn = t.closest('[data-qty-step]');
        if (stepBtn) {
          var input = this.dialog.querySelector('[data-qty]');
          var next = (parseInt(input.value, 10) || 1) + Number(stepBtn.dataset.qtyStep);
          input.value = Math.max(1, next);
          return;
        }

        if (t.closest('[data-qv-close]')) this.closeQuickView();
      }

      handleChange(e) {
        if (e.target.matches('[data-qty]')) {
          e.target.value = Math.max(1, parseInt(e.target.value, 10) || 1);
        }
      }

      handleKeydown(e) {
        var tab = e.target.closest('[role="tab"]');
        if (!tab) return;
        var i = this.tabs.indexOf(tab);
        var n = null;
        var len = this.tabs.length;
        if (e.key === 'ArrowRight') n = (i + 1) % len;
        else if (e.key === 'ArrowLeft') n = (i - 1 + len) % len;
        else if (e.key === 'Home') n = 0;
        else if (e.key === 'End') n = len - 1;
        if (n === null) return;
        e.preventDefault();
        this.tabs[n].focus();
        this.activateTab(this.tabs[n]);
      }

      pop(el) {
        el.classList.remove('is-pop', 'is-added');
        void el.offsetWidth;
        el.classList.add(el.matches('[data-wishlist]') ? 'is-pop' : 'is-added');
      }

      /* ---------- Size picker ---------- */
      openPicker(card) {
        card.classList.add('is-picking');
        var btn = card.querySelector('[data-pick]');
        var picker = card.querySelector('.bwg-card__picker');
        if (btn) btn.setAttribute('aria-expanded', 'true');
        if (picker) {
          picker.setAttribute('aria-hidden', 'false');
          picker.querySelectorAll('button').forEach((b) => b.removeAttribute('tabindex'));
          var first = picker.querySelector('.bwg-chip:not(:disabled)');
          if (first) first.focus({ preventScroll: true });
        }
      }

      closePickers(restoreFocus) {
        this.querySelectorAll('.bwg-card.is-picking').forEach((card) => {
          card.classList.remove('is-picking');
          var btn = card.querySelector('[data-pick]');
          var picker = card.querySelector('.bwg-card__picker');
          if (picker) {
            picker.setAttribute('aria-hidden', 'true');
            picker.querySelectorAll('button').forEach((b) => b.setAttribute('tabindex', '-1'));
          }
          if (btn) {
            btn.setAttribute('aria-expanded', 'false');
            if (restoreFocus) btn.focus({ preventScroll: true });
          }
        });
      }

      /* ---------- Tabs ---------- */
      activateTab(tab) {
        var id = tab.getAttribute('aria-controls');
        this.closePickers();
        this.tabs.forEach((t) => {
          var on = t === tab;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
        });
        this.panels.forEach((p) => {
          if (p.id === id) {
            if (!p.hidden) return;
            p.hidden = false;
            p.classList.remove('is-entering');
            void p.offsetWidth;
            p.classList.add('is-entering');
          } else {
            p.hidden = true;
          }
        });
        var url = tab.dataset.url;
        this.viewAll.forEach((a) => {
          if (url) { a.href = url; a.hidden = false; } else { a.hidden = true; }
        });
        this.moveIndicator();
        this.refreshArrows();

        var wrap = tab.closest('.bwg-fc__tabs-wrap');
        if (wrap && wrap.scrollWidth > wrap.clientWidth) {
          var left = tab.offsetLeft - (wrap.clientWidth - tab.offsetWidth) / 2;
          wrap.scrollTo({ left: left, behavior: 'smooth' });
        }
      }

      moveIndicator() {
        if (!this.indicator) return;
        var tab = this.tabs.find((t) => t.getAttribute('aria-selected') === 'true');
        if (!tab) return;
        this.indicator.style.width = tab.offsetWidth + 'px';
        this.indicator.style.transform = 'translateX(' + tab.offsetLeft + 'px)';
      }

      /* ---------- Carousel arrows ---------- */
      activePanel() {
        return this.panels.find((p) => !p.hidden) || this.panels[0];
      }

      activeTrack() {
        var panel = this.activePanel();
        return panel ? panel.querySelector('.bwg-fc__grid--carousel') : null;
      }

      refreshArrows() {
        var track = this.activeTrack();
        var max = track ? track.scrollWidth - track.clientWidth : 0;
        var overflow = max > 2;
        var atStart = !track || track.scrollLeft <= 2;
        var atEnd = !track || track.scrollLeft >= max - 2;

        var buttons = [];
        if (this.nav) {
          this.nav.classList.toggle('is-static', !overflow);
          buttons = buttons.concat(Array.from(this.nav.querySelectorAll('[data-arrow]')));
        }
        var panel = this.activePanel();
        var wrap = panel && panel.querySelector('.bwg-fc__slider-wrap');
        if (wrap) {
          wrap.classList.toggle('has-overflow', overflow);
          buttons = buttons.concat(Array.from(wrap.querySelectorAll('[data-arrow]')));
        }
        buttons.forEach((b) => {
          b.disabled = b.dataset.arrow === 'prev' ? atStart : atEnd;
        });
      }

      /* ---------- Helpers ---------- */
      toast(message) {
        var cs = getComputedStyle(this);
        BW.toast(message, {
          bg: cs.getPropertyValue('--gc-text').trim() || '#000',
          fg: cs.getPropertyValue('--gc-bg').trim() || '#fff'
        });
      }

      formatMoney(cents) {
        cents = Number(cents) || 0;
        var fmt = this.moneyFormat;
        var re = /\{\{\s*(\w+)\s*\}\}/;
        var num = function (n, decimals, thousands, decimal) {
          var fixed = (n / 100).toFixed(decimals);
          var parts = fixed.split('.');
          var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
          return whole + (parts[1] ? decimal + parts[1] : '');
        };
        if (!fmt || !re.test(fmt)) return num(cents, 2, ',', '.');
        var type = fmt.match(re)[1];
        var value;
        switch (type) {
          case 'amount_no_decimals': value = num(cents, 0, ',', '.'); break;
          case 'amount_with_comma_separator': value = num(cents, 2, '.', ','); break;
          case 'amount_no_decimals_with_comma_separator': value = num(cents, 0, '.', ','); break;
          case 'amount_with_apostrophe_separator': value = num(cents, 2, "'", '.'); break;
          case 'amount_with_space_separator': value = num(cents, 2, ' ', ','); break;
          default: value = num(cents, 2, ',', '.');
        }
        return fmt.replace(re, value);
      }

      /* ---------- Instant add to cart ---------- */
      async addToCart(variantId, quantity, btn) {
        if (btn) btn.classList.add('is-loading');
        var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        var canRender = cart && typeof cart.renderContents === 'function' && typeof cart.getSectionsToRender === 'function';

        var body = {
          id: Number(variantId),
          quantity: quantity,
          sections: canRender ? cart.getSectionsToRender().map((s) => s.id) : ['cart-icon-bubble'],
          sections_url: window.location.pathname
        };

        try {
          var res = await fetch(this.cartAddUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(body)
          });
          var data = await res.json();
          if (!res.ok || data.status) throw new Error(data.description || data.message || 'This item could not be added.');

          var card = btn && btn.closest('.bwg-card');
          this.closePickers();
          if (card) {
            var bag = card.querySelector('.bwg-card__cart');
            if (bag) this.pop(bag);
          }
          if (this.dialog && this.dialog.open) this.closeQuickView();

          if (canRender) {
            if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
            cart.classList.remove('is-empty');
            cart.renderContents(data);
          } else {
            this.refreshBubble(data.sections && data.sections['cart-icon-bubble']);
            this.toast('Added to bag');
          }

          if (typeof window.publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            window.publish(PUB_SUB_EVENTS.cartUpdate, { source: 'bw-collection-grid', productVariantId: variantId, cartData: data });
          }
          document.dispatchEvent(new CustomEvent('bw:cart:added', { detail: data }));
        } catch (err) {
          this.toast(err.message || 'Something went wrong. Please try again.');
        } finally {
          if (btn) btn.classList.remove('is-loading');
        }
      }

      refreshBubble(html) {
        var bubble = document.getElementById('cart-icon-bubble');
        if (!bubble || !html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var inner = doc.querySelector('.shopify-section');
        bubble.innerHTML = inner ? inner.innerHTML : doc.body.innerHTML;
      }

      /* ---------- Quick view ---------- */
      async openQuickView(handle) {
        if (!this.dialog) return;
        this.closePickers();
        var body = this.dialog.querySelector('[data-qv-body]');
        body.innerHTML = '<div class="bwg-qv__loading"><span class="bwg-spinner" aria-label="Loading"></span></div>';
        if (!this.dialog.open) {
          this.dialog.showModal();
          document.documentElement.classList.add('bw-lock');
        }
        try {
          var product = this.cache.get(handle);
          if (!product) {
            var res = await fetch(this.rootUrl + '/products/' + encodeURIComponent(handle) + '.js');
            if (!res.ok) throw new Error('Not found');
            product = await res.json();
            this.cache.set(handle, product);
          }
          this.renderQuickView(product);
        } catch (err) {
          body.innerHTML =
            '<div class="bwg-qv__loading"><p>This product could not be loaded. <a href="' +
            esc(this.rootUrl + '/products/' + handle) +
            '">Open the product page</a></p></div>';
        }
      }

      closeQuickView() {
        if (this.dialog && this.dialog.open) this.dialog.close();
      }

      renderQuickView(p) {
        this.qvProduct = p;
        var options = (p.options || []).map((o, i) => {
          if (typeof o === 'string') {
            var vals = [];
            p.variants.forEach((v) => { if (vals.indexOf(v.options[i]) === -1) vals.push(v.options[i]); });
            return { name: o, values: vals };
          }
          return o;
        });
        var single = p.variants.length === 1 && p.variants[0].title === 'Default Title';
        var initial = p.variants.find((v) => v.available) || p.variants[0];
        this.qvSelected = initial.options.slice();

        var images = (p.images || []).slice(0, 10);
        var first = (initial.featured_image && initial.featured_image.src) || images[0] || '';

        var thumbs = images.length > 1
          ? '<div class="bwg-qv__thumbs">' + images.map((src) =>
              '<button type="button" class="bwg-qv__thumb" data-thumb="' + esc(src) + '" aria-label="Show image">' +
              '<img src="' + esc(sized(src, 160)) + '" alt="" loading="lazy"></button>'
            ).join('') + '</div>'
          : '';

        var optionHtml = single ? '' : options.map((o, i) =>
          '<fieldset class="bwg-qv__option"><legend>' + esc(o.name) + '<span data-option-selected="' + i + '"></span></legend>' +
          '<div class="bwg-qv__values">' + o.values.map((val) =>
            '<button type="button" class="bwg-chip" data-option-index="' + i + '" data-value="' + esc(val) + '" aria-pressed="false">' + esc(val) + '</button>'
          ).join('') + '</div></fieldset>'
        ).join('');

        var desc = '';
        if (p.description) {
          var text = new DOMParser().parseFromString(p.description, 'text/html').body.textContent.replace(/\s+/g, ' ').trim();
          if (text) desc = '<p class="bwg-qv__desc">' + esc(text.length > 240 ? text.slice(0, 237).trim() + '…' : text) + '</p>';
        }

        var url = this.rootUrl + '/products/' + p.handle;

        this.dialog.querySelector('[data-qv-body]').innerHTML =
          '<div class="bwg-qv__grid">' +
            '<div class="bwg-qv__gallery">' +
              '<div class="bwg-qv__main"><img data-qv-main data-base="' + esc(first) + '" src="' + esc(sized(first, 1100)) + '" alt="' + esc(p.title) + '"></div>' +
              thumbs +
            '</div>' +
            '<div class="bwg-qv__info" data-qv-form>' +
              (this.showVendor && p.vendor ? '<p class="bwg-qv__vendor">' + esc(p.vendor) + '</p>' : '') +
              '<h2 class="bwg-qv__title">' + esc(p.title) + '</h2>' +
              '<p class="bwg-qv__price" data-qv-price></p>' +
              optionHtml +
              '<div class="bwg-qv__buy">' +
                '<div class="bwg-qv__qty">' +
                  '<button type="button" data-qty-step="-1" aria-label="Decrease quantity">−</button>' +
                  '<input type="number" min="1" value="1" data-qty aria-label="Quantity">' +
                  '<button type="button" data-qty-step="1" aria-label="Increase quantity">+</button>' +
                '</div>' +
                '<button type="button" class="bwg-btn bwg-btn--solid bwg-qv__add" data-qv-add data-add=""><span>Add to bag</span></button>' +
                '<button type="button" class="bwg-icon-btn bwg-qv__wish" data-wishlist="' + esc(p.handle) + '" aria-pressed="false" aria-label="Save to favourites">' + ICON_HEART + '</button>' +
              '</div>' +
              desc +
              '<a class="bwg-btn bwg-btn--link bwg-qv__details" data-qv-link href="' + esc(url) + '">View full details</a>' +
            '</div>' +
          '</div>';

        this.updateQuickView();
        BW.wishlist.sync(this.dialog);
        var close = this.dialog.querySelector('[data-qv-close]');
        if (close) close.focus();
      }

      currentVariant() {
        var sel = this.qvSelected;
        return this.qvProduct.variants.find((v) => v.options.every((o, i) => o === sel[i]));
      }

      selectOption(index, value) {
        var p = this.qvProduct;
        if (!p) return;
        this.qvSelected[index] = value;
        var v = this.currentVariant();
        if (!v || !v.available) {
          var alt = p.variants.find((x) => x.available && x.options[index] === value) ||
                    p.variants.find((x) => x.options[index] === value);
          if (alt) this.qvSelected = alt.options.slice();
        }
        this.updateQuickView();
      }

      updateQuickView() {
        var p = this.qvProduct;
        var sel = this.qvSelected;
        var root = this.dialog;
        var v = this.currentVariant();

        root.querySelectorAll('[data-option-index]').forEach((btn) => {
          var i = Number(btn.dataset.optionIndex);
          var val = btn.dataset.value;
          var selected = sel[i] === val;
          var available = p.variants.some((x) =>
            x.available && x.options[i] === val && x.options.every((o, j) => j === i || o === sel[j])
          );
          btn.classList.toggle('is-selected', selected);
          btn.classList.toggle('is-unavailable', !available);
          btn.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });
        root.querySelectorAll('[data-option-selected]').forEach((el) => {
          el.textContent = sel[Number(el.dataset.optionSelected)] || '';
        });

        var price = root.querySelector('[data-qv-price]');
        if (price) {
          var shown = v || p.variants[0];
          var html = '<span class="bwg-price__now">' + esc(this.formatMoney(shown.price)) + '</span>';
          if (shown.compare_at_price && shown.compare_at_price > shown.price) {
            html += '<s class="bwg-price__was">' + esc(this.formatMoney(shown.compare_at_price)) + '</s>';
          }
          price.innerHTML = html;
        }

        var add = root.querySelector('[data-qv-add]');
        if (add) {
          var label = add.querySelector('span');
          if (v && v.available) {
            add.disabled = false;
            add.dataset.add = v.id;
            label.textContent = 'Add to bag';
          } else {
            add.disabled = true;
            add.dataset.add = '';
            label.textContent = v ? 'Sold out' : 'Unavailable';
          }
        }

        var link = root.querySelector('[data-qv-link]');
        if (link && v) link.href = this.rootUrl + '/products/' + p.handle + '?variant=' + v.id;

        var main = root.querySelector('[data-qv-main]');
        if (v && v.featured_image && v.featured_image.src) this.setMainImage(v.featured_image.src);
        else if (main) this.markThumb(main.dataset.base);
      }

      setMainImage(src) {
        var main = this.dialog.querySelector('[data-qv-main]');
        if (!main || !src) return;
        if (main.dataset.base !== src) {
          main.dataset.base = src;
          main.src = sized(src, 1100);
        }
        this.markThumb(src);
      }

      markThumb(src) {
        var strip = function (u) { return (u || '').split('?')[0].replace(/^https?:/, ''); };
        var target = strip(src);
        this.dialog.querySelectorAll('[data-thumb]').forEach((t) => {
          t.classList.toggle('is-active', !!target && strip(t.dataset.thumb) === target);
        });
      }
    }

    customElements.define('bw-collection-grid', BWCollectionGrid);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bw-featured-collection"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('bw-featured-collection')) return;

    var BW = (window.BWStore = window.BWStore || {});

    /* ---------- Favourites (saved in the shopper's browser) ---------- */
    if (!BW.wishlist) {
      var KEY = 'bw-wishlist';
      var read = function () {
        try {
          var v = JSON.parse(localStorage.getItem(KEY) || '[]');
          return Array.isArray(v) ? v : [];
        } catch (e) {
          return [];
        }
      };
      BW.wishlist = {
        get: read,
        has: function (h) { return read().indexOf(h) > -1; },
        toggle: function (h) {
          var list = read();
          var i = list.indexOf(h);
          if (i > -1) list.splice(i, 1);
          else list.unshift(h);
          try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
          document.dispatchEvent(new CustomEvent('bw:wishlist:change', { detail: { list: list } }));
          return i === -1;
        },
        sync: function (root) {
          var list = read();
          (root || document).querySelectorAll('[data-wishlist]').forEach(function (btn) {
            var on = list.indexOf(btn.dataset.wishlist) > -1;
            btn.classList.toggle('is-active', on);
            btn.setAttribute('aria-pressed', on ? 'true' : 'false');
          });
        }
      };
      document.addEventListener('bw:wishlist:change', function () { BW.wishlist.sync(); });
      window.addEventListener('storage', function (e) { if (e.key === KEY) BW.wishlist.sync(); });
    }

    /* ---------- Toast ---------- */
    if (!BW.toast) {
      BW.toast = function (message, colors) {
        var el = document.querySelector('.bw-toast');
        if (!el) {
          el = document.createElement('div');
          el.className = 'bw-toast';
          el.setAttribute('role', 'status');
          el.setAttribute('aria-live', 'polite');
          document.body.appendChild(el);
        }
        if (colors) {
          el.style.background = colors.bg;
          el.style.color = colors.fg;
        }
        el.textContent = message;
        el.classList.add('is-visible');
        clearTimeout(el._timer);
        el._timer = setTimeout(function () { el.classList.remove('is-visible'); }, 2600);
      };
    }

    var esc = function (str) {
      return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    };
    var unesc = function (str) {
      var t = document.createElement('textarea');
      t.innerHTML = str || '';
      return t.value;
    };
    var sized = function (src, w) {
      if (!src) return '';
      return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
    };
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    var ICON_HEART =
      '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false"><path d="M12 20.3s-7.4-4.5-9.2-9.1C1.5 7.9 3.6 4.6 7 4.6c2 0 3.4 1.1 5 3 1.6-1.9 3-3 5-3 3.4 0 5.5 3.3 4.2 6.6-1.8 4.6-9.2 9.1-9.2 9.1z" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"/></svg>';

    class BWFeaturedCollection extends HTMLElement {
      connectedCallback() {
        var d = this.dataset;
        this.moneyFormat = (d.moneyFormat || '').replace(/<[^>]*>/g, '');
        this.cartAddUrl = d.cartAddUrl || '/cart/add.js';
        this.rootUrl = (d.rootUrl || '/').replace(/\/$/, '');
        this.showVendor = d.showVendor === 'true';
        this.price = {
          showCompare: d.showCompare === 'true',
          compareLabel: d.compareLabel || '',
          display: d.discountDisplay || 'percent',
          style: d.discountStyle || 'text',
          percentText: d.percentText || '[percent] OFF',
          amountText: d.amountText || 'Save [amount]'
        };
        this.badge = {
          show: d.showBadge === 'true',
          type: d.badgeType || 'percent',
          text: d.badgeText || '[discount] OFF',
          position: d.badgePosition || 'left'
        };
        this.taxNote = d.taxNote || '';
        this.addedLabel = d.addedLabel || 'Added';

        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.panels = Array.from(this.querySelectorAll('.bw-fc__panel'));
        this.indicator = this.querySelector('.bw-fc__indicator');
        this.groupBtns = Array.from(this.querySelectorAll('[data-group-btn]'));
        this.groupIndicator = this.querySelector('.bw-fc__group-indicator');
        this.tabsWrap = this.querySelector('[data-tabs-wrap]');
        if (this.tabsWrap) this.tabsWrap.addEventListener('scroll', () => this.refreshTabFade(), { passive: true });
        this.viewAll = Array.from(this.querySelectorAll('[data-view-all]'));
        this.nav = this.querySelector('[data-nav]');
        this.dialog = this.querySelector('.bw-qv');
        this.cache = new Map();

        this.addEventListener('click', this.handleClick.bind(this));
        this.addEventListener('keydown', this.handleKeydown.bind(this));
        this.addEventListener('change', this.handleChange.bind(this));
        this.addEventListener('mouseover', this.handleHover.bind(this));

        this.querySelectorAll('.bw-fc__grid--carousel').forEach((track) => {
          track.addEventListener('scroll', () => this.refreshArrows(), { passive: true });
          if (d.drag === 'true') this.enableDrag(track);
        });

        this.querySelectorAll('[data-swatches]').forEach((row) => {
          row.addEventListener('mouseleave', () => this.restoreSwatch(row));
        });

        if (window.ResizeObserver) {
          this.ro = new ResizeObserver(() => {
            this.moveIndicator();
            this.refreshArrows();
          });
          this.ro.observe(this);
        }
        if (document.fonts && document.fonts.ready) {
          document.fonts.ready.then(() => { this.moveIndicator(); this.refreshArrows(); });
        }
        this.moveIndicator();
        this.refreshArrows();

        this.setupReveal();
        this.numberTabs();
        this.restoreTab();
        this.setupCursor();

        if (this.dialog) {
          this.dialog.addEventListener('click', (e) => { if (e.target === this.dialog) this.closeQuickView(); });
          this.dialog.addEventListener('close', () => document.documentElement.classList.remove('bw-lock'));
        }

        BW.wishlist.sync(this);

        this.onDocClick = (e) => {
          if (!e.target.closest || !e.target.closest('.bw-quick, [data-pick]')) this.closePickers();
        };
        this.onDocKey = (e) => { if (e.key === 'Escape') this.closePickers(true); };
        document.addEventListener('click', this.onDocClick);
        document.addEventListener('keydown', this.onDocKey);

        this.onBlockSelect = (e) => {
          if (!this.contains(e.target)) return;
          var tab = e.target.closest && e.target.closest('[role="tab"]');
          if (tab) {
            if (tab.hidden && tab.dataset.group) this.activateGroup(tab.dataset.group);
            this.activateTab(tab);
          }
        };
        document.addEventListener('shopify:block:select', this.onBlockSelect);
      }

      disconnectedCallback() {
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
        document.removeEventListener('click', this.onDocClick);
        document.removeEventListener('keydown', this.onDocKey);
        if (this.onDragMove) {
          window.removeEventListener('pointermove', this.onDragMove);
          window.removeEventListener('pointerup', this.onDragEnd);
        }
        if (this.ro) this.ro.disconnect();
        if (this.io) this.io.disconnect();
        if (this.cursorRaf) cancelAnimationFrame(this.cursorRaf);
        document.documentElement.classList.remove('bw-lock');
      }

      /* ---------- Scroll reveal ---------- */
      setupReveal() {
        if (!this.classList.contains('bw-fc--reveal')) return;
        var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if ((window.Shopify && window.Shopify.designMode) || reduce || !('IntersectionObserver' in window)) {
          this.classList.add('is-revealed');
          return;
        }
        this.io = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.classList.add('is-revealed');
              this.io.disconnect();
            }
          });
        }, { rootMargin: '0px 0px -12% 0px', threshold: 0.05 });
        this.io.observe(this);
      }

      /* ---------- Floating "View" cursor ---------- */
      setupCursor() {
        var cursor = this.querySelector('.bw-cursor');
        if (!cursor || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
        var pos = { x: 0, y: 0 };
        var target = { x: 0, y: 0 };
        var on = false;
        var loop = () => {
          pos.x += (target.x - pos.x) * 0.22;
          pos.y += (target.y - pos.y) * 0.22;
          cursor.style.transform = 'translate3d(' + pos.x + 'px,' + pos.y + 'px,0)';
          if (on || Math.abs(target.x - pos.x) > 0.5) this.cursorRaf = requestAnimationFrame(loop);
          else this.cursorRaf = null;
        };
        this.addEventListener('pointermove', (e) => {
          if (e.pointerType !== 'mouse') return;
          var media = e.target.closest('.bw-card__media');
          var blocked = e.target.closest('button, .bw-quick, .bw-card__actions');
          var show = !!media && !blocked && !this.isDragging;
          target.x = e.clientX;
          target.y = e.clientY;
          if (show && !on) { pos.x = target.x; pos.y = target.y; }
          on = show;
          cursor.classList.toggle('is-on', show);
          if (!this.cursorRaf) this.cursorRaf = requestAnimationFrame(loop);
        });
        this.addEventListener('pointerleave', () => { on = false; cursor.classList.remove('is-on'); });
      }

      /* ---------- Drag to scroll (mouse) ---------- */
      enableDrag(track) {
        var drag = null;
        track.addEventListener('dragstart', (e) => e.preventDefault());
        track.addEventListener('pointerdown', (e) => {
          if (e.pointerType !== 'mouse' || e.button !== 0) return;
          if (e.target.closest('button, .bw-swatch, .bw-quick')) return;
          drag = { track: track, x: e.clientX, left: track.scrollLeft, moved: false };
          this.activeDrag = drag;
        });
        track.addEventListener('click', (e) => {
          if (this.suppressClick) {
            e.preventDefault();
            e.stopPropagation();
          }
        }, true);

        if (this.onDragMove) return;
        this.onDragMove = (e) => {
          var dg = this.activeDrag;
          if (!dg) return;
          var dx = e.clientX - dg.x;
          if (!dg.moved && Math.abs(dx) > 6) {
            dg.moved = true;
            this.isDragging = true;
            dg.track.classList.add('is-dragging');
          }
          if (dg.moved) dg.track.scrollLeft = dg.left - dx;
        };
        this.onDragEnd = () => {
          var dg = this.activeDrag;
          if (!dg) return;
          this.activeDrag = null;
          if (dg.moved) {
            this.suppressClick = true;
            setTimeout(() => { this.suppressClick = false; }, 60);
            var card = dg.track.querySelector('.bw-card');
            var gap = parseFloat(getComputedStyle(dg.track).columnGap) || 0;
            var step = card ? card.getBoundingClientRect().width + gap : dg.track.clientWidth;
            var snap = Math.round(dg.track.scrollLeft / step) * step;
            dg.track.classList.remove('is-dragging');
            dg.track.scrollTo({ left: snap, behavior: 'smooth' });
          }
          this.isDragging = false;
        };
        window.addEventListener('pointermove', this.onDragMove);
        window.addEventListener('pointerup', this.onDragEnd);
      }

      /* ---------- Swatch image preview ---------- */
      handleHover(e) {
        var sw = e.target.closest && e.target.closest('[data-swatch-image]');
        if (!sw) return;
        var card = sw.closest('.bw-card');
        var img = card && card.querySelector('.bw-card__img--primary');
        if (!img) return;
        if (!img.dataset.origSrc) {
          img.dataset.origSrc = img.currentSrc || img.src;
          img.dataset.origSrcset = img.getAttribute('srcset') || '';
        }
        var row = sw.closest('[data-swatches]');
        row.querySelectorAll('.bw-swatch').forEach((x) => x.classList.toggle('is-active', x === sw));
        var url = sw.dataset.swatchImage;
        if (img.dataset.current === url) return;
        img.dataset.current = url;
        img.removeAttribute('srcset');
        img.src = url;
        img.classList.remove('is-swapping');
        void img.offsetWidth;
        img.classList.add('is-swapping');
      }

      restoreSwatch(row) {
        var card = row.closest('.bw-card');
        var img = card && card.querySelector('.bw-card__img--primary');
        row.querySelectorAll('.bw-swatch').forEach((x) => x.classList.remove('is-active'));
        if (!img || !img.dataset.origSrc) return;
        if (img.dataset.origSrcset) img.setAttribute('srcset', img.dataset.origSrcset);
        img.src = img.dataset.origSrc;
        img.dataset.current = '';
      }

      /* ---------- Events ---------- */
      handleClick(e) {
        var t = e.target;

        var groupBtn = t.closest('[data-group-btn]');
        if (groupBtn) { this.activateGroup(groupBtn.dataset.groupBtn); return; }

        var tab = t.closest('[role="tab"]');
        if (tab) { this.activateTab(tab); return; }

        var wish = t.closest('[data-wishlist]');
        if (wish) {
          e.preventDefault();
          var added = BW.wishlist.toggle(wish.dataset.wishlist);
          this.pop(wish);
          this.toast(added ? 'Saved to favourites' : 'Removed from favourites');
          return;
        }

        var pick = t.closest('[data-pick]');
        if (pick) {
          e.preventDefault();
          var card = pick.closest('.bw-card');
          var open = card.classList.contains('is-picking');
          this.closePickers();
          if (!open) this.openPicker(card);
          return;
        }

        if (t.closest('[data-pick-close]')) { e.preventDefault(); this.closePickers(true); return; }

        var qv = t.closest('[data-quick-view]');
        if (qv) { e.preventDefault(); this.openQuickView(qv.dataset.quickView); return; }

        var add = t.closest('[data-add]');
        if (add) {
          e.preventDefault();
          if (add.disabled || !add.dataset.add) return;
          var form = add.closest('[data-qv-form]');
          var qtyInput = form && form.querySelector('[data-qty]');
          var qty = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
          this.addToCart(add.dataset.add, qty, add);
          return;
        }

        var arrow = t.closest('[data-arrow]');
        if (arrow) {
          var track = this.activeTrack();
          if (!track) return;
          var cardEl = track.querySelector('.bw-card');
          var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
          var step = cardEl ? cardEl.getBoundingClientRect().width + gap : track.clientWidth;
          track.scrollBy({ left: arrow.dataset.arrow === 'next' ? step : -step, behavior: 'smooth' });
          return;
        }

        var thumb = t.closest('[data-thumb]');
        if (thumb) { this.setMainImage(thumb.dataset.thumb); return; }

        var opt = t.closest('[data-option-index]');
        if (opt) { this.selectOption(Number(opt.dataset.optionIndex), opt.dataset.value); return; }

        var stepBtn = t.closest('[data-qty-step]');
        if (stepBtn) {
          var input = this.dialog.querySelector('[data-qty]');
          var next = (parseInt(input.value, 10) || 1) + Number(stepBtn.dataset.qtyStep);
          input.value = Math.max(1, next);
          return;
        }

        if (t.closest('[data-qv-close]')) this.closeQuickView();
      }

      handleChange(e) {
        if (e.target.matches('[data-qty]')) {
          e.target.value = Math.max(1, parseInt(e.target.value, 10) || 1);
        }
      }

      handleKeydown(e) {
        var tab = e.target.closest('[role="tab"]');
        if (!tab) return;
        var list = this.tabs.filter((x) => !x.hidden);
        var i = list.indexOf(tab);
        var n = null;
        var len = list.length;
        if (e.key === 'ArrowRight') n = (i + 1) % len;
        else if (e.key === 'ArrowLeft') n = (i - 1 + len) % len;
        else if (e.key === 'Home') n = 0;
        else if (e.key === 'End') n = len - 1;
        if (n === null) return;
        e.preventDefault();
        list[n].focus();
        this.activateTab(list[n]);
      }

      pop(el) {
        el.classList.remove('is-pop', 'is-added');
        void el.offsetWidth;
        el.classList.add(el.matches('[data-wishlist]') ? 'is-pop' : 'is-added');
      }

      /* ---------- Size panel on touch screens ---------- */
      openPicker(card) {
        card.classList.add('is-picking');
        var btn = card.querySelector('[data-pick]');
        if (btn) btn.setAttribute('aria-expanded', 'true');
        var first = card.querySelector('.bw-quick .bw-chip:not(:disabled)');
        if (first) first.focus({ preventScroll: true });
      }

      closePickers(restoreFocus) {
        this.querySelectorAll('.bw-card.is-picking').forEach((card) => {
          card.classList.remove('is-picking');
          var btn = card.querySelector('[data-pick]');
          if (btn) {
            btn.setAttribute('aria-expanded', 'false');
            if (restoreFocus) btn.focus({ preventScroll: true });
          }
        });
      }

      /* ---------- Tabs ---------- */
      activateTab(tab, instant) {
        var id = tab.getAttribute('aria-controls');
        this.closePickers();
        this.tabs.forEach((t) => {
          var on = t === tab;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
        });

        var incoming = this.panels.find((p) => p.id === id);
        var outgoing = this.panels.find((p) => !p.hidden && p !== incoming);
        var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        var swap = () => {
          this.panels.forEach((p) => {
            p.classList.remove('is-leaving');
            if (p === incoming) {
              if (!p.hidden) return;
              p.hidden = false;
              p.classList.remove('is-entering');
              void p.offsetWidth;
              p.classList.add('is-entering');
              var track = p.querySelector('.bw-fc__grid--carousel');
              if (track) track.scrollLeft = 0;
            } else {
              p.hidden = true;
            }
          });
          this.refreshArrows();
        };
        clearTimeout(this.swapTimer);
        if (incoming && incoming.hidden && outgoing && !instant && !reduce) {
          this.panels.forEach((p) => { if (p !== outgoing) p.classList.remove('is-leaving'); });
          outgoing.classList.add('is-leaving');
          this.swapTimer = setTimeout(swap, 190);
        } else {
          swap();
        }

        this.updateViewAll(tab);
        this.moveIndicator();
        this.refreshArrows();

        if (this.dataset.rememberTab === 'true' && !instant) {
          try { sessionStorage.setItem('bw-fc-tab-' + this.dataset.sectionId, tab.id); } catch (e) {}
        }

        var wrap = tab.closest('.bw-fc__tabs-wrap');
        if (wrap && wrap.scrollWidth > wrap.clientWidth) {
          var left = tab.offsetLeft - (wrap.clientWidth - tab.offsetWidth) / 2;
          wrap.scrollTo({ left: left, behavior: instant ? 'auto' : 'smooth' });
        }
      }

      updateViewAll(tab) {
        var url = tab.dataset.url;
        var labelEl = tab.querySelector('.bw-fc__tab-label');
        var name = labelEl ? labelEl.dataset.text : '';
        var count = tab.dataset.count || '';
        this.viewAll.forEach((a) => {
          if (url) { a.href = url; a.hidden = false; } else { a.hidden = true; }
          var holder = a.parentElement;
          var nameEl = a.querySelector('[data-va-name]');
          var countEl = a.querySelector('[data-va-count]');
          if (nameEl && nameEl.textContent !== name) {
            holder.classList.add('is-swapping');
            clearTimeout(a._vaTimer);
            a._vaTimer = setTimeout(() => {
              nameEl.textContent = name;
              holder.classList.remove('is-swapping');
            }, 180);
          }
          if (countEl) countEl.textContent = count;
        });
      }

      numberTabs() {
        var n = 0;
        this.tabs.forEach((t) => {
          var el = t.querySelector('[data-tab-index]');
          if (t.hidden) return;
          n += 1;
          if (el) el.textContent = (n < 10 ? '0' : '') + n;
        });
      }

      restoreTab() {
        if (this.dataset.rememberTab !== 'true' || (window.Shopify && window.Shopify.designMode)) return;
        var saved;
        try { saved = sessionStorage.getItem('bw-fc-tab-' + this.dataset.sectionId); } catch (e) {}
        var tab = saved && this.tabs.find((t) => t.id === saved);
        if (!tab || tab.getAttribute('aria-selected') === 'true') return;
        if (tab.hidden && tab.dataset.group) this.activateGroup(tab.dataset.group, true);
        this.activateTab(tab, true);
      }

      moveIndicator() {
        this.moveGroupIndicator();
        this.refreshTabFade();
        if (!this.indicator) return;
        var tab = this.tabs.find((t) => t.getAttribute('aria-selected') === 'true');
        if (!tab || !tab.offsetWidth) return;
        this.indicator.style.width = tab.offsetWidth + 'px';
        this.indicator.style.transform = 'translateX(' + tab.offsetLeft + 'px)';
        if (!this.indicator.classList.contains('is-ready')) {
          requestAnimationFrame(() => this.indicator.classList.add('is-ready'));
        }
      }

      /* ---------- Groups (e.g. Men / Women) ---------- */
      activateGroup(name, instant) {
        this.groupBtns.forEach((b) => b.setAttribute('aria-pressed', b.dataset.groupBtn === name ? 'true' : 'false'));
        var first = null;
        this.tabs.forEach((t) => {
          var g = t.dataset.group || '';
          var show = !g || g === name;
          t.hidden = !show;
          if (show && g === name && !first) first = t;
        });
        if (!first) first = this.tabs.find((t) => !t.hidden);
        if (this.tabsWrap) this.tabsWrap.scrollLeft = 0;
        if (first) {
          var current = this.tabs.find((t) => t.getAttribute('aria-selected') === 'true');
          if (current === first) {
            this.moveIndicator();
          } else {
            this.activateTab(first, instant);
          }
        }
        this.numberTabs();
        this.moveGroupIndicator();
      }

      moveGroupIndicator() {
        var ind = this.groupIndicator;
        if (!ind) return;
        var btn = this.groupBtns.find((b) => b.getAttribute('aria-pressed') === 'true');
        if (!btn || !btn.offsetWidth) return;
        ind.style.width = btn.offsetWidth + 'px';
        ind.style.transform = 'translateX(' + btn.offsetLeft + 'px)';
        if (!ind.classList.contains('is-ready')) requestAnimationFrame(() => ind.classList.add('is-ready'));
      }

      refreshTabFade() {
        var w = this.tabsWrap;
        if (!w) return;
        var max = w.scrollWidth - w.clientWidth;
        w.classList.toggle('can-left', max > 2 && w.scrollLeft > 4);
        w.classList.toggle('can-right', max > 2 && w.scrollLeft < max - 4);
      }

      /* ---------- Carousel arrows, progress, counter ---------- */
      activePanel() {
        return this.panels.find((p) => !p.hidden) || this.panels[0];
      }

      activeTrack() {
        var panel = this.activePanel();
        return panel ? panel.querySelector('.bw-fc__grid--carousel') : null;
      }

      refreshArrows() {
        var track = this.activeTrack();
        var max = track ? track.scrollWidth - track.clientWidth : 0;
        var overflow = max > 2;
        var atStart = !track || track.scrollLeft <= 2;
        var atEnd = !track || track.scrollLeft >= max - 2;

        var buttons = [];
        if (this.nav) {
          this.nav.classList.toggle('is-static', !overflow);
          buttons = buttons.concat(Array.from(this.nav.querySelectorAll('[data-arrow]')));
        }
        var panel = this.activePanel();
        var wrap = panel && panel.querySelector('.bw-fc__slider-wrap');
        if (wrap) {
          wrap.classList.toggle('has-overflow', overflow);
          buttons = buttons.concat(Array.from(wrap.querySelectorAll('[data-arrow]')));
        }
        buttons.forEach((b) => {
          b.disabled = b.dataset.arrow === 'prev' ? atStart : atEnd;
        });

        var row = panel && panel.querySelector('[data-progress-row]');
        if (!row) return;
        row.classList.toggle('is-hidden', !overflow);
        if (!overflow) return;
        var ratio = track.clientWidth / track.scrollWidth;
        var pos = Math.min(1, Math.max(0, track.scrollLeft / max));
        var bar = row.querySelector('[data-progress]');
        bar.style.setProperty('--w', (ratio * 100).toFixed(2) + '%');
        bar.style.setProperty('--x', ((pos * (1 - ratio)) / ratio * 100).toFixed(2) + '%');

        var nowEl = row.querySelector('[data-counter-now]');
        var totalEl = row.querySelector('[data-counter-total]');
        if (nowEl && totalEl) {
          var cards = track.querySelectorAll(':scope > .bw-card');
          var total = cards.length;
          var first = cards[0];
          var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
          var step = first ? first.getBoundingClientRect().width + gap : track.clientWidth;
          var visible = Math.max(1, Math.round((track.clientWidth + gap) / step));
          var seen = atEnd ? total : Math.min(total, Math.round(track.scrollLeft / step) + visible);
          nowEl.textContent = pad(seen);
          totalEl.textContent = pad(total);
        }
      }

      /* ---------- Helpers ---------- */
      toast(message) {
        var cs = getComputedStyle(this);
        BW.toast(message, {
          bg: cs.getPropertyValue('--fc-text').trim() || '#000',
          fg: cs.getPropertyValue('--fc-bg').trim() || '#fff'
        });
      }

      formatMoney(cents, trimZeros) {
        cents = Number(cents) || 0;
        var fmt = this.moneyFormat;
        var re = /\{\{\s*(\w+)\s*\}\}/;
        var num = function (n, decimals, thousands, decimal) {
          var fixed = (n / 100).toFixed(decimals);
          var parts = fixed.split('.');
          var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
          var frac = parts[1];
          if (trimZeros && frac && /^0+$/.test(frac)) frac = '';
          return whole + (frac ? decimal + frac : '');
        };
        if (!fmt || !re.test(fmt)) return num(cents, 2, ',', '.');
        var type = fmt.match(re)[1];
        var value;
        switch (type) {
          case 'amount_no_decimals': value = num(cents, 0, ',', '.'); break;
          case 'amount_with_comma_separator': value = num(cents, 2, '.', ','); break;
          case 'amount_no_decimals_with_comma_separator': value = num(cents, 0, '.', ','); break;
          case 'amount_with_apostrophe_separator': value = num(cents, 2, "'", '.'); break;
          case 'amount_with_space_separator': value = num(cents, 2, ' ', ','); break;
          default: value = num(cents, 2, ',', '.');
        }
        return unesc(fmt.replace(re, value));
      }

      priceHtml(v) {
        var cfg = this.price;
        var price = Number(v.price) || 0;
        var compare = Number(v.compare_at_price) || 0;
        var sale = compare > price;
        var html = '<span class="bw-price__now' + (sale ? ' is-sale' : '') + '">' + esc(this.formatMoney(price)) + '</span>';
        if (sale && cfg.showCompare) {
          html += '<span class="bw-price__was">' +
            (cfg.compareLabel ? '<span class="bw-price__label">' + esc(unesc(cfg.compareLabel)) + '</span>' : '') +
            '<s>' + esc(this.formatMoney(compare)) + '</s></span>';
        }
        if (sale && cfg.display !== 'none') {
          var save = compare - price;
          var pct = Math.max(1, Math.round((save * 100) / compare)) + '%';
          var pctTxt = esc(unesc(cfg.percentText)).split('[percent]').join(esc(pct));
          var amtTxt = esc(unesc(cfg.amountText)).split('[amount]').join(esc(this.formatMoney(save, true)));
          var txt = cfg.display === 'amount' ? amtTxt
            : cfg.display === 'both' ? amtTxt + ' <span class="bw-price__sep" aria-hidden="true">·</span> ' + pctTxt
            : pctTxt;
          html += '<span class="bw-price__save bw-price__save--' + esc(cfg.style) + '">' + txt + '</span>';
        }
        return html;
      }

      badgeText(v) {
        var price = Number(v.price) || 0;
        var compare = Number(v.compare_at_price) || 0;
        if (!this.badge.show || !(compare > price) || !v.available) return '';
        var save = compare - price;
        var value = this.badge.type === 'amount'
          ? this.formatMoney(save, true)
          : Math.max(1, Math.round((save * 100) / compare)) + '%';
        return unesc(this.badge.text).split('[discount]').join(value);
      }

      /* ---------- Instant add to cart ---------- */
      async addToCart(variantId, quantity, btn) {
        if (btn) btn.classList.add('is-loading');
        var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        var canRender = cart && typeof cart.renderContents === 'function' && typeof cart.getSectionsToRender === 'function';

        var body = {
          id: Number(variantId),
          quantity: quantity,
          sections: canRender ? cart.getSectionsToRender().map((s) => s.id) : ['cart-icon-bubble'],
          sections_url: window.location.pathname
        };

        try {
          var res = await fetch(this.cartAddUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(body)
          });
          var data = await res.json();
          if (!res.ok || data.status) throw new Error(data.description || data.message || 'This item could not be added.');

          var card = btn && btn.closest('.bw-card');
          this.closePickers();
          if (card) {
            var bag = card.querySelector('.bw-card__touch-add');
            if (bag) this.pop(bag);
          }
          if (btn && btn.matches('.bw-quick__btn')) this.flashAdded(btn);
          if (this.dialog && this.dialog.open) this.closeQuickView();

          if (canRender) {
            if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
            cart.classList.remove('is-empty');
            cart.renderContents(data);
          } else {
            this.refreshBubble(data.sections && data.sections['cart-icon-bubble']);
            this.toast('Added to bag');
          }

          if (typeof window.publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            window.publish(PUB_SUB_EVENTS.cartUpdate, { source: 'bw-featured-collection', productVariantId: variantId, cartData: data });
          }
          document.dispatchEvent(new CustomEvent('bw:cart:added', { detail: data }));
        } catch (err) {
          this.toast(err.message || 'Something went wrong. Please try again.');
        } finally {
          if (btn) btn.classList.remove('is-loading');
        }
      }

      flashAdded(btn) {
        var label = btn.querySelector('[data-label]');
        if (!label) return;
        if (!label.dataset.original) label.dataset.original = label.textContent;
        label.textContent = this.addedLabel;
        btn.classList.add('is-done');
        clearTimeout(btn._doneTimer);
        btn._doneTimer = setTimeout(() => {
          label.textContent = label.dataset.original;
          btn.classList.remove('is-done');
        }, 1800);
      }

      refreshBubble(html) {
        var bubble = document.getElementById('cart-icon-bubble');
        if (!bubble || !html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var inner = doc.querySelector('.shopify-section');
        bubble.innerHTML = inner ? inner.innerHTML : doc.body.innerHTML;
      }

      /* ---------- Quick view ---------- */
      async openQuickView(handle) {
        if (!this.dialog) return;
        this.closePickers();
        var body = this.dialog.querySelector('[data-qv-body]');
        body.innerHTML = '<div class="bw-qv__loading"><span class="bw-spinner" aria-label="Loading"></span></div>';
        if (!this.dialog.open) {
          this.dialog.showModal();
          document.documentElement.classList.add('bw-lock');
        }
        try {
          var product = this.cache.get(handle);
          if (!product) {
            var res = await fetch(this.rootUrl + '/products/' + encodeURIComponent(handle) + '.js');
            if (!res.ok) throw new Error('Not found');
            product = await res.json();
            this.cache.set(handle, product);
          }
          this.renderQuickView(product);
        } catch (err) {
          body.innerHTML =
            '<div class="bw-qv__loading"><p>This product could not be loaded. <a href="' +
            esc(this.rootUrl + '/products/' + handle) +
            '">Open the product page</a></p></div>';
        }
      }

      closeQuickView() {
        if (this.dialog && this.dialog.open) this.dialog.close();
      }

      renderQuickView(p) {
        this.qvProduct = p;
        var options = (p.options || []).map((o, i) => {
          if (typeof o === 'string') {
            var vals = [];
            p.variants.forEach((v) => { if (vals.indexOf(v.options[i]) === -1) vals.push(v.options[i]); });
            return { name: o, values: vals };
          }
          return o;
        });
        var single = p.variants.length === 1 && p.variants[0].title === 'Default Title';
        var initial = p.variants.find((v) => v.available) || p.variants[0];
        this.qvSelected = initial.options.slice();

        var images = (p.images || []).slice(0, 10);
        var first = (initial.featured_image && initial.featured_image.src) || images[0] || '';

        var thumbs = images.length > 1
          ? '<div class="bw-qv__thumbs">' + images.map((src) =>
              '<button type="button" class="bw-qv__thumb" data-thumb="' + esc(src) + '" aria-label="Show image">' +
              '<img src="' + esc(sized(src, 160)) + '" alt="" loading="lazy"></button>'
            ).join('') + '</div>'
          : '';

        var optionHtml = single ? '' : options.map((o, i) =>
          '<fieldset class="bw-qv__option"><legend>' + esc(o.name) + '<span data-option-selected="' + i + '"></span></legend>' +
          '<div class="bw-qv__values">' + o.values.map((val) =>
            '<button type="button" class="bw-chip" data-option-index="' + i + '" data-value="' + esc(val) + '" aria-pressed="false">' + esc(val) + '</button>'
          ).join('') + '</div></fieldset>'
        ).join('');

        var desc = '';
        if (p.description) {
          var text = new DOMParser().parseFromString(p.description, 'text/html').body.textContent.replace(/\s+/g, ' ').trim();
          if (text) desc = '<p class="bw-qv__desc">' + esc(text.length > 260 ? text.slice(0, 257).trim() + '…' : text) + '</p>';
        }

        var url = this.rootUrl + '/products/' + p.handle;

        this.dialog.querySelector('[data-qv-body]').innerHTML =
          '<div class="bw-qv__grid">' +
            '<div class="bw-qv__gallery">' +
              '<div class="bw-qv__main">' +
                '<img data-qv-main data-base="' + esc(first) + '" src="' + esc(sized(first, 1100)) + '" alt="' + esc(p.title) + '">' +
                '<div class="bw-card__badges bw-card__badges--' + esc(this.badge.position) + '" data-qv-badge hidden><span class="bw-badge bw-badge--discount"></span></div>' +
              '</div>' +
              thumbs +
            '</div>' +
            '<div class="bw-qv__info" data-qv-form>' +
              (this.showVendor && p.vendor ? '<p class="bw-qv__vendor">' + esc(p.vendor) + '</p>' : '') +
              '<h2 class="bw-qv__title">' + esc(p.title) + '</h2>' +
              '<div class="bw-qv__price-wrap">' +
                '<div class="bw-price bw-price--inline bw-qv__price" data-qv-price></div>' +
                (this.taxNote ? '<p class="bw-qv__tax">' + esc(unesc(this.taxNote)) + '</p>' : '') +
              '</div>' +
              '<div class="bw-qv__rule" aria-hidden="true"></div>' +
              optionHtml +
              '<div class="bw-qv__buy">' +
                '<div class="bw-qv__qty">' +
                  '<button type="button" data-qty-step="-1" aria-label="Decrease quantity">−</button>' +
                  '<input type="number" min="1" value="1" data-qty aria-label="Quantity">' +
                  '<button type="button" data-qty-step="1" aria-label="Increase quantity">+</button>' +
                '</div>' +
                '<button type="button" class="bw-btn bw-btn--solid bw-qv__add" data-qv-add data-add=""><span>Add to bag</span></button>' +
                '<button type="button" class="bw-icon-btn bw-qv__wish" data-wishlist="' + esc(p.handle) + '" aria-pressed="false" aria-label="Save to favourites">' + ICON_HEART + '</button>' +
              '</div>' +
              desc +
              '<a class="bw-btn bw-btn--link bw-qv__details" data-qv-link href="' + esc(url) + '">View full details</a>' +
            '</div>' +
          '</div>';

        this.updateQuickView();
        BW.wishlist.sync(this.dialog);
        var close = this.dialog.querySelector('[data-qv-close]');
        if (close) close.focus();
      }

      currentVariant() {
        var sel = this.qvSelected;
        return this.qvProduct.variants.find((v) => v.options.every((o, i) => o === sel[i]));
      }

      selectOption(index, value) {
        var p = this.qvProduct;
        if (!p) return;
        this.qvSelected[index] = value;
        var v = this.currentVariant();
        if (!v || !v.available) {
          var alt = p.variants.find((x) => x.available && x.options[index] === value) ||
                    p.variants.find((x) => x.options[index] === value);
          if (alt) this.qvSelected = alt.options.slice();
        }
        this.updateQuickView();
      }

      updateQuickView() {
        var p = this.qvProduct;
        var sel = this.qvSelected;
        var root = this.dialog;
        var v = this.currentVariant();

        root.querySelectorAll('[data-option-index]').forEach((btn) => {
          var i = Number(btn.dataset.optionIndex);
          var val = btn.dataset.value;
          var selected = sel[i] === val;
          var available = p.variants.some((x) =>
            x.available && x.options[i] === val && x.options.every((o, j) => j === i || o === sel[j])
          );
          btn.classList.toggle('is-selected', selected);
          btn.classList.toggle('is-unavailable', !available);
          btn.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });
        root.querySelectorAll('[data-option-selected]').forEach((el) => {
          el.textContent = sel[Number(el.dataset.optionSelected)] || '';
        });

        var shown = v || p.variants[0];
        var price = root.querySelector('[data-qv-price]');
        if (price) price.innerHTML = this.priceHtml(shown);

        var badgeWrap = root.querySelector('[data-qv-badge]');
        if (badgeWrap) {
          var bt = this.badgeText(shown);
          badgeWrap.hidden = !bt;
          badgeWrap.firstChild.textContent = bt;
        }

        var add = root.querySelector('[data-qv-add]');
        if (add) {
          var label = add.querySelector('span');
          if (v && v.available) {
            add.disabled = false;
            add.dataset.add = v.id;
            label.textContent = 'Add to bag';
          } else {
            add.disabled = true;
            add.dataset.add = '';
            label.textContent = v ? 'Sold out' : 'Unavailable';
          }
        }

        var link = root.querySelector('[data-qv-link]');
        if (link && v) link.href = this.rootUrl + '/products/' + p.handle + '?variant=' + v.id;

        var main = root.querySelector('[data-qv-main]');
        if (v && v.featured_image && v.featured_image.src) this.setMainImage(v.featured_image.src);
        else if (main) this.markThumb(main.dataset.base);
      }

      setMainImage(src) {
        var main = this.dialog.querySelector('[data-qv-main]');
        if (!main || !src) return;
        if (main.dataset.base !== src) {
          main.dataset.base = src;
          main.src = sized(src, 1100);
        }
        this.markThumb(src);
      }

      markThumb(src) {
        var strip = function (u) { return (u || '').split('?')[0].replace(/^https?:/, ''); };
        var target = strip(src);
        this.dialog.querySelectorAll('[data-thumb]').forEach((t) => {
          t.classList.toggle('is-active', !!target && strip(t.dataset.thumb) === target);
        });
      }
    }

    customElements.define('bw-featured-collection', BWFeaturedCollection);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bw-newsletter"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('bw-newsletter')) return;

    var STORE_EMAIL = 'bw-newsletter-email';
    var STORE_SECTION = 'bw-newsletter-section';
    var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

    var store = {
      get: function (k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } },
      set: function (k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} },
      del: function (k) { try { sessionStorage.removeItem(k); } catch (e) {} }
    };

    function whenOmnisendReady(cb, tries) {
      tries = tries || 0;
      if (window.omnisend && typeof window.omnisend.identifyContact === 'function') return cb(window.omnisend);
      if (tries > 40) return;
      setTimeout(function () { whenOmnisendReady(cb, tries + 1); }, 250);
    }

    class BWNewsletter extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form.bwn__form');
        if (!this.form) return;
        this.input = this.form.querySelector('input[type="email"]');
        this.button = this.form.querySelector('[data-submit]');
        this.status = this.form.querySelector('[data-status]');
        this.body = this.form.querySelector('[data-form-body]');
        this.success = this.form.querySelector('[data-success]');
        var postedEl = this.form.querySelector('[data-posted]');
        var posted = postedEl && postedEl.dataset.posted === 'true';

        this.form.noValidate = true;
        this.form.addEventListener('submit', this.onSubmit.bind(this));
        if (this.input) this.input.addEventListener('input', () => this.clearError());

        var copy = this.form.querySelector('[data-copy]');
        if (copy) copy.addEventListener('click', () => this.copyCode(copy));

        if (posted) this.handlePosted();
      }

      handlePosted() {
        var submittedFrom = store.get(STORE_SECTION);
        // Another signup form on the page was submitted: keep this one as a normal form.
        if (submittedFrom && submittedFrom !== this.dataset.sectionId) {
          this.body.hidden = false;
          this.success.hidden = true;
          return;
        }
        var email = store.get(STORE_EMAIL);
        store.del(STORE_EMAIL);
        store.del(STORE_SECTION);
        this.success.focus({ preventScroll: true });
        if (email) this.notifyOmnisend(email);
      }

      notifyOmnisend(email) {
        var brand = this.dataset.omnisendBrand;
        var eventName = this.dataset.omnisendEvent;
        if (!brand && !window.omnisend) return;
        whenOmnisendReady(function (omnisend) {
          try {
            omnisend.identifyContact({ email: email });
            if (eventName) {
              omnisend.push(['track', eventName, {
                origin: 'api',
                eventVersion: '',
                properties: { source: 'bw-newsletter-section', page: window.location.pathname }
              }]);
            }
          } catch (e) {}
        });
      }

      onSubmit(e) {
        var email = (this.input.value || '').trim();
        this.input.value = email;
        if (!EMAIL_RE.test(email)) {
          e.preventDefault();
          this.showError(email ? 'Please enter a valid email address.' : 'Please enter your email address.');
          this.input.focus();
          return;
        }
        store.set(STORE_EMAIL, email);
        store.set(STORE_SECTION, this.dataset.sectionId);
        if (this.button) this.button.classList.add('is-loading');
      }

      showError(msg) {
        this.status.textContent = msg;
        this.status.hidden = false;
        this.input.setAttribute('aria-invalid', 'true');
      }

      clearError() {
        if (this.status.hidden) return;
        this.status.hidden = true;
        this.input.removeAttribute('aria-invalid');
      }

      copyCode(btn) {
        var code = this.form.querySelector('[data-code]');
        if (!code) return;
        var label = btn.querySelector('span');
        var done = function () {
          label.textContent = 'Copied';
          setTimeout(function () { label.textContent = 'Copy code'; }, 1800);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code.textContent.trim()).then(done, function () {});
        } else {
          var range = document.createRange();
          range.selectNodeContents(code);
          var sel = window.getSelection();
          sel.removeAllRanges();
          sel.addRange(range);
          try { document.execCommand('copy'); done(); } catch (err) {}
          sel.removeAllRanges();
        }
      }
    }

    customElements.define('bw-newsletter', BWNewsletter);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bw-recommendations"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('bw-recommendations')) return;

    var BW = (window.BWStore = window.BWStore || {});

    /* ---------- Favourites (saved in the shopper's browser) ---------- */
    if (!BW.wishlist) {
      var KEY = 'bw-wishlist';
      var read = function () {
        try {
          var v = JSON.parse(localStorage.getItem(KEY) || '[]');
          return Array.isArray(v) ? v : [];
        } catch (e) {
          return [];
        }
      };
      BW.wishlist = {
        get: read,
        has: function (h) { return read().indexOf(h) > -1; },
        toggle: function (h) {
          var list = read();
          var i = list.indexOf(h);
          if (i > -1) list.splice(i, 1);
          else list.unshift(h);
          try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
          document.dispatchEvent(new CustomEvent('bw:wishlist:change', { detail: { list: list } }));
          return i === -1;
        },
        sync: function (root) {
          var list = read();
          (root || document).querySelectorAll('[data-wishlist]').forEach(function (btn) {
            var on = list.indexOf(btn.dataset.wishlist) > -1;
            btn.classList.toggle('is-active', on);
            btn.setAttribute('aria-pressed', on ? 'true' : 'false');
          });
        }
      };
      document.addEventListener('bw:wishlist:change', function () { BW.wishlist.sync(); });
      window.addEventListener('storage', function (e) { if (e.key === KEY) BW.wishlist.sync(); });
    }

    /* ---------- Toast ---------- */
    if (!BW.toast) {
      BW.toast = function (message, colors) {
        var el = document.querySelector('.bw-toast');
        if (!el) {
          el = document.createElement('div');
          el.className = 'bw-toast';
          el.setAttribute('role', 'status');
          el.setAttribute('aria-live', 'polite');
          document.body.appendChild(el);
        }
        if (colors) {
          el.style.background = colors.bg;
          el.style.color = colors.fg;
        }
        el.textContent = message;
        el.classList.add('is-visible');
        clearTimeout(el._timer);
        el._timer = setTimeout(function () { el.classList.remove('is-visible'); }, 2600);
      };
    }

    var esc = function (str) {
      return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    };
    var sized = function (src, w) {
      if (!src) return '';
      return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
    };
    var ICON_HEART =
      '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false"><path d="M12 20.3s-7.4-4.5-9.2-9.1C1.5 7.9 3.6 4.6 7 4.6c2 0 3.4 1.1 5 3 1.6-1.9 3-3 5-3 3.4 0 5.5 3.3 4.2 6.6-1.8 4.6-9.2 9.1-9.2 9.1z" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"/></svg>';

    class BWRecommendations extends HTMLElement {
      connectedCallback() {
        if (this.dataset.loaded === 'true') { this.finish(); return; }
        this.load();
      }

      /* ---------- Load recommendations after the page ---------- */
      async load() {
        var params = new URLSearchParams({
          product_id: this.dataset.productId,
          section_id: this.dataset.sectionId,
          limit: this.dataset.fetchLimit || this.dataset.limit || '8',
          intent: this.dataset.intent || 'related'
        });
        try {
          var res = await fetch(this.dataset.url + '?' + params.toString());
          if (!res.ok) throw new Error('Request failed');
          var html = await res.text();
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('bw-recommendations');
          if (!fresh || fresh.querySelector('[data-empty]')) { this.empty(); return; }
          this.dataset.source = fresh.dataset.source || '';
          this.innerHTML = fresh.innerHTML;
          this.finish(true);
        } catch (err) {
          this.empty();
        }
      }

      finish(animate) {
        this.prune();
        if (!this.querySelector('.bwr-card:not(.bwr-card--skeleton)')) { this.empty(); return; }
        this.init();
        var panel = this.querySelector('.bwr__panel');
        if (animate && panel) panel.classList.add('is-entering');
      }

      prune() {
        var grid = this.querySelector('.bwr__grid');
        if (!grid) return;
        var current = this.dataset.productId;
        grid.querySelectorAll('[data-product-id]').forEach(function (card) {
          if (card.dataset.productId === current) card.remove();
        });
        var cards = Array.from(grid.children);
        if (this.dataset.shuffle === 'true') {
          for (var i = cards.length - 1; i > 0; i--) {
            var j = Math.floor(Math.random() * (i + 1));
            var tmp = cards[i]; cards[i] = cards[j]; cards[j] = tmp;
          }
          cards.forEach(function (card, idx) {
            card.style.setProperty('--i', Math.min(idx, 7));
            grid.appendChild(card);
          });
        }
        var limit = parseInt(this.dataset.limit, 10) || cards.length;
        cards.slice(limit).forEach(function (card) { card.remove(); });
      }

      empty() {
        if (window.Shopify && window.Shopify.designMode) {
          var panel = this.querySelector('.bwr__panel');
          var note = '<p class="bwr__editor-note">No recommendations for this product yet. Choose a fallback collection in the section settings. This message only shows in the theme editor.</p>';
          if (panel) panel.outerHTML = note; else this.insertAdjacentHTML('beforeend', note);
          return;
        }
        this.classList.add('is-hidden');
      }

      init() {
        this.moneyFormat = this.dataset.moneyFormat || '';
        this.cartAddUrl = this.dataset.cartAddUrl || '/cart/add.js';
        this.rootUrl = (this.dataset.rootUrl || '/').replace(/\/$/, '');
        this.showVendor = this.dataset.showVendor === 'true';
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.panels = Array.from(this.querySelectorAll('.bwr__panel'));
        this.indicator = this.querySelector('.bwr__indicator');
        this.viewAll = Array.from(this.querySelectorAll('[data-view-all]'));
        this.nav = this.querySelector('[data-nav]');
        this.dialog = this.querySelector('.bwr-qv');
        this.cache = new Map();

        this.addEventListener('click', this.handleClick.bind(this));
        this.addEventListener('keydown', this.handleKeydown.bind(this));
        this.addEventListener('change', this.handleChange.bind(this));

        this.querySelectorAll('.bwr__grid--carousel').forEach((track) => {
          track.addEventListener('scroll', () => this.refreshArrows(), { passive: true });
        });

        if (window.ResizeObserver) {
          this.ro = new ResizeObserver(() => {
            this.moveIndicator();
            this.refreshArrows();
          });
          this.ro.observe(this);
        }
        if (document.fonts && document.fonts.ready) {
          document.fonts.ready.then(() => { this.moveIndicator(); this.refreshArrows(); });
        }
        this.moveIndicator();
        this.refreshArrows();

        if (this.dialog) {
          this.dialog.addEventListener('click', (e) => { if (e.target === this.dialog) this.closeQuickView(); });
          this.dialog.addEventListener('close', () => document.documentElement.classList.remove('bw-lock'));
        }

        BW.wishlist.sync(this);

        this.onDocClick = (e) => {
          if (!e.target.closest || !e.target.closest('.bwr-card__picker, [data-pick]')) this.closePickers();
        };
        this.onDocKey = (e) => { if (e.key === 'Escape') this.closePickers(true); };
        document.addEventListener('click', this.onDocClick);
        document.addEventListener('keydown', this.onDocKey);

        this.onBlockSelect = (e) => {
          if (!this.contains(e.target)) return;
          var tab = e.target.closest && e.target.closest('[role="tab"]');
          if (tab) this.activateTab(tab);
        };
        document.addEventListener('shopify:block:select', this.onBlockSelect);
      }

      disconnectedCallback() {
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
        document.removeEventListener('click', this.onDocClick);
        document.removeEventListener('keydown', this.onDocKey);
        if (this.ro) this.ro.disconnect();
        document.documentElement.classList.remove('bw-lock');
      }

      /* ---------- Events ---------- */
      handleClick(e) {
        var t = e.target;

        var tab = t.closest('[role="tab"]');
        if (tab) { this.activateTab(tab); return; }

        var wish = t.closest('[data-wishlist]');
        if (wish) {
          e.preventDefault();
          var added = BW.wishlist.toggle(wish.dataset.wishlist);
          this.pop(wish);
          this.toast(added ? 'Saved to favourites' : 'Removed from favourites');
          return;
        }

        var pick = t.closest('[data-pick]');
        if (pick) {
          e.preventDefault();
          var card = pick.closest('.bwr-card');
          var open = card.classList.contains('is-picking');
          this.closePickers();
          if (!open) this.openPicker(card);
          return;
        }

        if (t.closest('[data-pick-close]')) { e.preventDefault(); this.closePickers(true); return; }

        var qv = t.closest('[data-quick-view]');
        if (qv) { e.preventDefault(); this.openQuickView(qv.dataset.quickView); return; }

        var add = t.closest('[data-add]');
        if (add) {
          e.preventDefault();
          if (add.disabled || !add.dataset.add) return;
          var form = add.closest('[data-qv-form]');
          var qtyInput = form && form.querySelector('[data-qty]');
          var qty = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
          this.addToCart(add.dataset.add, qty, add);
          return;
        }

        var arrow = t.closest('[data-arrow]');
        if (arrow) {
          var track = this.activeTrack();
          if (!track) return;
          var cardEl = track.querySelector('.bwr-card');
          var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
          var step = cardEl ? cardEl.getBoundingClientRect().width + gap : track.clientWidth;
          track.scrollBy({ left: arrow.dataset.arrow === 'next' ? step : -step, behavior: 'smooth' });
          return;
        }

        var thumb = t.closest('[data-thumb]');
        if (thumb) { this.setMainImage(thumb.dataset.thumb); return; }

        var opt = t.closest('[data-option-index]');
        if (opt) { this.selectOption(Number(opt.dataset.optionIndex), opt.dataset.value); return; }

        var stepBtn = t.closest('[data-qty-step]');
        if (stepBtn) {
          var input = this.dialog.querySelector('[data-qty]');
          var next = (parseInt(input.value, 10) || 1) + Number(stepBtn.dataset.qtyStep);
          input.value = Math.max(1, next);
          return;
        }

        if (t.closest('[data-qv-close]')) this.closeQuickView();
      }

      handleChange(e) {
        if (e.target.matches('[data-qty]')) {
          e.target.value = Math.max(1, parseInt(e.target.value, 10) || 1);
        }
      }

      handleKeydown(e) {
        var tab = e.target.closest('[role="tab"]');
        if (!tab) return;
        var i = this.tabs.indexOf(tab);
        var n = null;
        var len = this.tabs.length;
        if (e.key === 'ArrowRight') n = (i + 1) % len;
        else if (e.key === 'ArrowLeft') n = (i - 1 + len) % len;
        else if (e.key === 'Home') n = 0;
        else if (e.key === 'End') n = len - 1;
        if (n === null) return;
        e.preventDefault();
        this.tabs[n].focus();
        this.activateTab(this.tabs[n]);
      }

      pop(el) {
        el.classList.remove('is-pop', 'is-added');
        void el.offsetWidth;
        el.classList.add(el.matches('[data-wishlist]') ? 'is-pop' : 'is-added');
      }

      /* ---------- Size picker ---------- */
      openPicker(card) {
        card.classList.add('is-picking');
        var btn = card.querySelector('[data-pick]');
        var picker = card.querySelector('.bwr-card__picker');
        if (btn) btn.setAttribute('aria-expanded', 'true');
        if (picker) {
          picker.setAttribute('aria-hidden', 'false');
          picker.querySelectorAll('button').forEach((b) => b.removeAttribute('tabindex'));
          var first = picker.querySelector('.bwr-chip:not(:disabled)');
          if (first) first.focus({ preventScroll: true });
        }
      }

      closePickers(restoreFocus) {
        this.querySelectorAll('.bwr-card.is-picking').forEach((card) => {
          card.classList.remove('is-picking');
          var btn = card.querySelector('[data-pick]');
          var picker = card.querySelector('.bwr-card__picker');
          if (picker) {
            picker.setAttribute('aria-hidden', 'true');
            picker.querySelectorAll('button').forEach((b) => b.setAttribute('tabindex', '-1'));
          }
          if (btn) {
            btn.setAttribute('aria-expanded', 'false');
            if (restoreFocus) btn.focus({ preventScroll: true });
          }
        });
      }

      /* ---------- Tabs ---------- */
      activateTab(tab) {
        var id = tab.getAttribute('aria-controls');
        this.closePickers();
        this.tabs.forEach((t) => {
          var on = t === tab;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
        });
        this.panels.forEach((p) => {
          if (p.id === id) {
            if (!p.hidden) return;
            p.hidden = false;
            p.classList.remove('is-entering');
            void p.offsetWidth;
            p.classList.add('is-entering');
          } else {
            p.hidden = true;
          }
        });
        var url = tab.dataset.url;
        this.viewAll.forEach((a) => {
          if (url) { a.href = url; a.hidden = false; } else { a.hidden = true; }
        });
        this.moveIndicator();
        this.refreshArrows();

        var wrap = tab.closest('.bwr__tabs-wrap');
        if (wrap && wrap.scrollWidth > wrap.clientWidth) {
          var left = tab.offsetLeft - (wrap.clientWidth - tab.offsetWidth) / 2;
          wrap.scrollTo({ left: left, behavior: 'smooth' });
        }
      }

      moveIndicator() {
        if (!this.indicator) return;
        var tab = this.tabs.find((t) => t.getAttribute('aria-selected') === 'true');
        if (!tab) return;
        this.indicator.style.width = tab.offsetWidth + 'px';
        this.indicator.style.transform = 'translateX(' + tab.offsetLeft + 'px)';
      }

      /* ---------- Carousel arrows ---------- */
      activePanel() {
        return this.panels.find((p) => !p.hidden) || this.panels[0];
      }

      activeTrack() {
        var panel = this.activePanel();
        return panel ? panel.querySelector('.bwr__grid--carousel') : null;
      }

      refreshArrows() {
        var track = this.activeTrack();
        var max = track ? track.scrollWidth - track.clientWidth : 0;
        var overflow = max > 2;
        var atStart = !track || track.scrollLeft <= 2;
        var atEnd = !track || track.scrollLeft >= max - 2;

        var buttons = [];
        if (this.nav) {
          this.nav.classList.toggle('is-static', !overflow);
          buttons = buttons.concat(Array.from(this.nav.querySelectorAll('[data-arrow]')));
        }
        var panel = this.activePanel();
        var wrap = panel && panel.querySelector('.bwr__slider-wrap');
        if (wrap) {
          wrap.classList.toggle('has-overflow', overflow);
          buttons = buttons.concat(Array.from(wrap.querySelectorAll('[data-arrow]')));
        }
        buttons.forEach((b) => {
          b.disabled = b.dataset.arrow === 'prev' ? atStart : atEnd;
        });
      }

      /* ---------- Helpers ---------- */
      toast(message) {
        var cs = getComputedStyle(this);
        BW.toast(message, {
          bg: cs.getPropertyValue('--rc-text').trim() || '#000',
          fg: cs.getPropertyValue('--rc-bg').trim() || '#fff'
        });
      }

      formatMoney(cents) {
        cents = Number(cents) || 0;
        var fmt = this.moneyFormat;
        var re = /\{\{\s*(\w+)\s*\}\}/;
        var num = function (n, decimals, thousands, decimal) {
          var fixed = (n / 100).toFixed(decimals);
          var parts = fixed.split('.');
          var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
          return whole + (parts[1] ? decimal + parts[1] : '');
        };
        if (!fmt || !re.test(fmt)) return num(cents, 2, ',', '.');
        var type = fmt.match(re)[1];
        var value;
        switch (type) {
          case 'amount_no_decimals': value = num(cents, 0, ',', '.'); break;
          case 'amount_with_comma_separator': value = num(cents, 2, '.', ','); break;
          case 'amount_no_decimals_with_comma_separator': value = num(cents, 0, '.', ','); break;
          case 'amount_with_apostrophe_separator': value = num(cents, 2, "'", '.'); break;
          case 'amount_with_space_separator': value = num(cents, 2, ' ', ','); break;
          default: value = num(cents, 2, ',', '.');
        }
        return fmt.replace(re, value);
      }

      /* ---------- Instant add to cart ---------- */
      async addToCart(variantId, quantity, btn) {
        if (btn) btn.classList.add('is-loading');
        var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        var canRender = cart && typeof cart.renderContents === 'function' && typeof cart.getSectionsToRender === 'function';

        var body = {
          id: Number(variantId),
          quantity: quantity,
          sections: canRender ? cart.getSectionsToRender().map((s) => s.id) : ['cart-icon-bubble'],
          sections_url: window.location.pathname
        };

        try {
          var res = await fetch(this.cartAddUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(body)
          });
          var data = await res.json();
          if (!res.ok || data.status) throw new Error(data.description || data.message || 'This item could not be added.');

          var card = btn && btn.closest('.bwr-card');
          this.closePickers();
          if (card) {
            var bag = card.querySelector('.bwr-card__cart');
            if (bag) this.pop(bag);
          }
          if (this.dialog && this.dialog.open) this.closeQuickView();

          if (canRender) {
            if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
            cart.classList.remove('is-empty');
            cart.renderContents(data);
          } else {
            this.refreshBubble(data.sections && data.sections['cart-icon-bubble']);
            this.toast('Added to bag');
          }

          if (typeof window.publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            window.publish(PUB_SUB_EVENTS.cartUpdate, { source: 'bw-recommendations', productVariantId: variantId, cartData: data });
          }
          document.dispatchEvent(new CustomEvent('bw:cart:added', { detail: data }));
        } catch (err) {
          this.toast(err.message || 'Something went wrong. Please try again.');
        } finally {
          if (btn) btn.classList.remove('is-loading');
        }
      }

      refreshBubble(html) {
        var bubble = document.getElementById('cart-icon-bubble');
        if (!bubble || !html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var inner = doc.querySelector('.shopify-section');
        bubble.innerHTML = inner ? inner.innerHTML : doc.body.innerHTML;
      }

      /* ---------- Quick view ---------- */
      async openQuickView(handle) {
        if (!this.dialog) return;
        this.closePickers();
        var body = this.dialog.querySelector('[data-qv-body]');
        body.innerHTML = '<div class="bwr-qv__loading"><span class="bwr-spinner" aria-label="Loading"></span></div>';
        if (!this.dialog.open) {
          this.dialog.showModal();
          document.documentElement.classList.add('bw-lock');
        }
        try {
          var product = this.cache.get(handle);
          if (!product) {
            var res = await fetch(this.rootUrl + '/products/' + encodeURIComponent(handle) + '.js');
            if (!res.ok) throw new Error('Not found');
            product = await res.json();
            this.cache.set(handle, product);
          }
          this.renderQuickView(product);
        } catch (err) {
          body.innerHTML =
            '<div class="bwr-qv__loading"><p>This product could not be loaded. <a href="' +
            esc(this.rootUrl + '/products/' + handle) +
            '">Open the product page</a></p></div>';
        }
      }

      closeQuickView() {
        if (this.dialog && this.dialog.open) this.dialog.close();
      }

      renderQuickView(p) {
        this.qvProduct = p;
        var options = (p.options || []).map((o, i) => {
          if (typeof o === 'string') {
            var vals = [];
            p.variants.forEach((v) => { if (vals.indexOf(v.options[i]) === -1) vals.push(v.options[i]); });
            return { name: o, values: vals };
          }
          return o;
        });
        var single = p.variants.length === 1 && p.variants[0].title === 'Default Title';
        var initial = p.variants.find((v) => v.available) || p.variants[0];
        this.qvSelected = initial.options.slice();

        var images = (p.images || []).slice(0, 10);
        var first = (initial.featured_image && initial.featured_image.src) || images[0] || '';

        var thumbs = images.length > 1
          ? '<div class="bwr-qv__thumbs">' + images.map((src) =>
              '<button type="button" class="bwr-qv__thumb" data-thumb="' + esc(src) + '" aria-label="Show image">' +
              '<img src="' + esc(sized(src, 160)) + '" alt="" loading="lazy"></button>'
            ).join('') + '</div>'
          : '';

        var optionHtml = single ? '' : options.map((o, i) =>
          '<fieldset class="bwr-qv__option"><legend>' + esc(o.name) + '<span data-option-selected="' + i + '"></span></legend>' +
          '<div class="bwr-qv__values">' + o.values.map((val) =>
            '<button type="button" class="bwr-chip" data-option-index="' + i + '" data-value="' + esc(val) + '" aria-pressed="false">' + esc(val) + '</button>'
          ).join('') + '</div></fieldset>'
        ).join('');

        var desc = '';
        if (p.description) {
          var text = new DOMParser().parseFromString(p.description, 'text/html').body.textContent.replace(/\s+/g, ' ').trim();
          if (text) desc = '<p class="bwr-qv__desc">' + esc(text.length > 240 ? text.slice(0, 237).trim() + '…' : text) + '</p>';
        }

        var url = this.rootUrl + '/products/' + p.handle;

        this.dialog.querySelector('[data-qv-body]').innerHTML =
          '<div class="bwr-qv__grid">' +
            '<div class="bwr-qv__gallery">' +
              '<div class="bwr-qv__main"><img data-qv-main data-base="' + esc(first) + '" src="' + esc(sized(first, 1100)) + '" alt="' + esc(p.title) + '"></div>' +
              thumbs +
            '</div>' +
            '<div class="bwr-qv__info" data-qv-form>' +
              (this.showVendor && p.vendor ? '<p class="bwr-qv__vendor">' + esc(p.vendor) + '</p>' : '') +
              '<h2 class="bwr-qv__title">' + esc(p.title) + '</h2>' +
              '<p class="bwr-qv__price" data-qv-price></p>' +
              optionHtml +
              '<div class="bwr-qv__buy">' +
                '<div class="bwr-qv__qty">' +
                  '<button type="button" data-qty-step="-1" aria-label="Decrease quantity">−</button>' +
                  '<input type="number" min="1" value="1" data-qty aria-label="Quantity">' +
                  '<button type="button" data-qty-step="1" aria-label="Increase quantity">+</button>' +
                '</div>' +
                '<button type="button" class="bwr-btn bwr-btn--solid bwr-qv__add" data-qv-add data-add=""><span>Add to bag</span></button>' +
                '<button type="button" class="bwr-icon-btn bwr-qv__wish" data-wishlist="' + esc(p.handle) + '" aria-pressed="false" aria-label="Save to favourites">' + ICON_HEART + '</button>' +
              '</div>' +
              desc +
              '<a class="bwr-btn bwr-btn--link bwr-qv__details" data-qv-link href="' + esc(url) + '">View full details</a>' +
            '</div>' +
          '</div>';

        this.updateQuickView();
        BW.wishlist.sync(this.dialog);
        var close = this.dialog.querySelector('[data-qv-close]');
        if (close) close.focus();
      }

      currentVariant() {
        var sel = this.qvSelected;
        return this.qvProduct.variants.find((v) => v.options.every((o, i) => o === sel[i]));
      }

      selectOption(index, value) {
        var p = this.qvProduct;
        if (!p) return;
        this.qvSelected[index] = value;
        var v = this.currentVariant();
        if (!v || !v.available) {
          var alt = p.variants.find((x) => x.available && x.options[index] === value) ||
                    p.variants.find((x) => x.options[index] === value);
          if (alt) this.qvSelected = alt.options.slice();
        }
        this.updateQuickView();
      }

      updateQuickView() {
        var p = this.qvProduct;
        var sel = this.qvSelected;
        var root = this.dialog;
        var v = this.currentVariant();

        root.querySelectorAll('[data-option-index]').forEach((btn) => {
          var i = Number(btn.dataset.optionIndex);
          var val = btn.dataset.value;
          var selected = sel[i] === val;
          var available = p.variants.some((x) =>
            x.available && x.options[i] === val && x.options.every((o, j) => j === i || o === sel[j])
          );
          btn.classList.toggle('is-selected', selected);
          btn.classList.toggle('is-unavailable', !available);
          btn.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });
        root.querySelectorAll('[data-option-selected]').forEach((el) => {
          el.textContent = sel[Number(el.dataset.optionSelected)] || '';
        });

        var price = root.querySelector('[data-qv-price]');
        if (price) {
          var shown = v || p.variants[0];
          var html = '<span class="bwr-price__now">' + esc(this.formatMoney(shown.price)) + '</span>';
          if (shown.compare_at_price && shown.compare_at_price > shown.price) {
            html += '<s class="bwr-price__was">' + esc(this.formatMoney(shown.compare_at_price)) + '</s>';
          }
          price.innerHTML = html;
        }

        var add = root.querySelector('[data-qv-add]');
        if (add) {
          var label = add.querySelector('span');
          if (v && v.available) {
            add.disabled = false;
            add.dataset.add = v.id;
            label.textContent = 'Add to bag';
          } else {
            add.disabled = true;
            add.dataset.add = '';
            label.textContent = v ? 'Sold out' : 'Unavailable';
          }
        }

        var link = root.querySelector('[data-qv-link]');
        if (link && v) link.href = this.rootUrl + '/products/' + p.handle + '?variant=' + v.id;

        var main = root.querySelector('[data-qv-main]');
        if (v && v.featured_image && v.featured_image.src) this.setMainImage(v.featured_image.src);
        else if (main) this.markThumb(main.dataset.base);
      }

      setMainImage(src) {
        var main = this.dialog.querySelector('[data-qv-main]');
        if (!main || !src) return;
        if (main.dataset.base !== src) {
          main.dataset.base = src;
          main.src = sized(src, 1100);
        }
        this.markThumb(src);
      }

      markThumb(src) {
        var strip = function (u) { return (u || '').split('?')[0].replace(/^https?:/, ''); };
        var target = strip(src);
        this.dialog.querySelectorAll('[data-thumb]').forEach((t) => {
          t.classList.toggle('is-active', !!target && strip(t.dataset.thumb) === target);
        });
      }
    }

    customElements.define('bw-recommendations', BWRecommendations);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bw-transformation"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('bw-transformation')) return;

    class BWTransformation extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form');
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const editing = window.Shopify && window.Shopify.designMode;

        if (this.classList.contains('bwx--reveal') && !reduce && !editing && 'IntersectionObserver' in window) {
          this.classList.add('js-reveal');
          this.io = new IntersectionObserver((entries) => {
            if (entries.some((e) => e.isIntersecting)) {
              this.classList.add('is-revealed');
              this.io.disconnect();
            }
          }, { threshold: 0.15 });
          this.io.observe(this);
        }

        if (!this.form) return;
        this.form.noValidate = true;
        this.status = this.form.querySelector('[data-status]');
        this.button = this.form.querySelector('[data-submit]');
        this.form.addEventListener('submit', (e) => this.onSubmit(e));
        this.form.addEventListener('input', (e) => {
          if (e.target.matches('.bwx__input')) e.target.removeAttribute('aria-invalid');
        });

        const posted = this.form.querySelector('[data-posted]');
        const hasError = this.status && !this.status.hidden;
        if (posted && posted.dataset.posted === 'true') this.prepareBooking();
        if ((posted && posted.dataset.posted === 'true') || hasError) {
          if (hasError) this.classList.add('is-revealed');
          this.classList.add('is-revealed');
          requestAnimationFrame(() => {
            this.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
            const target = hasError ? this.form.querySelector('[aria-invalid="true"], .bwx__input') : this.form.querySelector('[data-success]');
            if (target) target.focus({ preventScroll: true });
          });
        }
      }

      disconnectedCallback() {
        if (this.io) this.io.disconnect();
        clearInterval(this.timer);
      }

      /* Pass the visitor's name and email to Calendly so they don't type them twice */
      prepareBooking() {
        const link = this.querySelector('.bwx__success:not([hidden]) [data-booking]');
        if (!link) return;
        let saved = {};
        try { saved = JSON.parse(sessionStorage.getItem('bwx-contact') || '{}'); } catch (err) {}
        try {
          const url = new URL(link.href);
          if (/calendly\.com$/.test(url.hostname) || /\.calendly\.com$/.test(url.hostname)) {
            if (saved.name && !url.searchParams.has('name')) url.searchParams.set('name', saved.name);
            if (saved.email && !url.searchParams.has('email')) url.searchParams.set('email', saved.email);
            link.href = url.toString();
          }
        } catch (err) {}
        const delay = parseInt(link.dataset.redirect, 10) || 0;
        const counter = this.querySelector('[data-countdown]');
        if (!delay || (window.Shopify && window.Shopify.designMode)) return;
        let left = delay;
        const tick = () => {
          if (counter) counter.textContent = `Taking you to the booking page in ${left} second${left === 1 ? '' : 's'}…`;
          if (left <= 0) {
            clearInterval(this.timer);
            if (link.target === '_blank') { if (counter) counter.textContent = ''; window.open(link.href, '_blank', 'noopener'); }
            else window.location.href = link.href;
          }
          left -= 1;
        };
        tick();
        this.timer = setInterval(tick, 1000);
        link.addEventListener('click', () => { clearInterval(this.timer); if (counter) counter.textContent = ''; }, { once: true });
      }

      onSubmit(e) {
        const fields = Array.from(this.form.querySelectorAll('.bwx__input'));
        let firstBad = null;
        fields.forEach((f) => {
          f.value = f.value.trim() === '' ? '' : f.value;
          const bad = !f.checkValidity();
          f.toggleAttribute('aria-invalid', bad);
          if (bad) f.setAttribute('aria-invalid', 'true');
          if (bad && !firstBad) firstBad = f;
        });
        if (firstBad) {
          e.preventDefault();
          if (this.status) {
            const label = this.form.querySelector(`label[for="${firstBad.id}"]`);
            const name = label ? label.textContent.replace('*', '').trim() : 'this field';
            this.status.textContent = firstBad.validity.valueMissing
              ? `Please fill in ${name.toLowerCase()}.`
              : `Please check ${name.toLowerCase()}.`;
            this.status.hidden = false;
          }
          firstBad.focus();
          return;
        }
        if (this.status) this.status.hidden = true;
        if (this.button) this.button.classList.add('is-loading');
        try {
          const val = (n) => { const el = this.form.querySelector(`[name="${n}"]`); return el ? el.value.trim() : ''; };
          sessionStorage.setItem('bwx-contact', JSON.stringify({ name: val('contact[name]'), email: val('contact[email]') }));
        } catch (err) {}
      }
    }
    customElements.define('bw-transformation', BWTransformation);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  /* ---------- Shared helpers ---------- */
  window.BW = window.BW || (function () {
    const root = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const MAP = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };
    const esc = (v) => String(v == null ? '' : v).replace(/[&<>"']/g, (c) => MAP[c]);
    const PH = new RegExp('\\{' + '\\{\\s*(\\w+)\\s*\\}' + '\\}');
    const fmt = (cents, precision, thousands, decimal) => {
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;
      if (cents == null || isNaN(cents)) return '0';
      const parts = (Number(cents) / 100).toFixed(precision).split('.');
      const whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return whole + (parts[1] ? decimal + parts[1] : '');
    };
    const money = (cents, format) => {
      format = format || ('$' + '{' + '{amount}' + '}');
      const m = format.match(PH);
      if (!m) return format;
      let v;
      switch (m[1]) {
        case 'amount_no_decimals': v = fmt(cents, 0); break;
        case 'amount_with_comma_separator': v = fmt(cents, 2, '.', ','); break;
        case 'amount_no_decimals_with_comma_separator': v = fmt(cents, 0, '.', ','); break;
        case 'amount_with_apostrophe_separator': v = fmt(cents, 2, "'", '.'); break;
        case 'amount_no_decimals_with_space_separator': v = fmt(cents, 0, ' ', ''); break;
        case 'amount_with_space_separator': v = fmt(cents, 2, ' ', ','); break;
        case 'amount_with_period_and_space_separator': v = fmt(cents, 2, ' ', '.'); break;
        default: v = fmt(cents, 2);
      }
      return format.replace(PH, v);
    };
    const sized = (url, w) => {
      if (!url) return '';
      try { const u = new URL(url, window.location.origin); u.searchParams.set('width', w); return u.toString(); } catch (e) { return url; }
    };
    const config = (id) => {
      const el = document.getElementById('BwConfig-' + id);
      try { return el ? JSON.parse(el.textContent) : {}; } catch (e) { return {}; }
    };
    /* Move overlays to the end of <body> so they sit above everything; returns true if moved */
    const portal = (el) => {
      if (el.parentElement === document.body) return false;
      document.querySelectorAll('body > ' + el.localName + '#' + CSS.escape(el.id)).forEach((x) => x !== el && x.remove());
      const wrap = el.closest('.bwh') || document.querySelector('#shopify-section-' + CSS.escape(el.dataset.sectionId) + ' .bwh');
      if (wrap) el.setAttribute('style', wrap.getAttribute('style') || '');
      document.body.appendChild(el);
      return true;
    };
    let locks = 0;
    const lock = (on) => {
      locks = Math.max(0, locks + (on ? 1 : -1));
      document.documentElement.classList.toggle('bwm-lock', locks > 0);
    };
    const trap = (e, scope) => {
      const items = Array.from(scope.querySelectorAll('a[href], button:not([disabled]), input:not([type="hidden"]), textarea, summary'))
        .filter((el) => el.offsetWidth || el.offsetHeight || el === document.activeElement);
      if (!items.length) return;
      const first = items[0];
      const last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    };
    const onUnload = (el) => {
      const fn = (e) => { if (e.detail && e.detail.sectionId === el.dataset.sectionId) el.remove(); };
      document.addEventListener('shopify:section:unload', fn);
      return () => document.removeEventListener('shopify:section:unload', fn);
    };
    const card = (p, L, fmtStr) => {
      const img = p.image ? '<img class="bwp__img" src="' + esc(sized(p.image, 480)) + '" alt="' + esc(p.title) + '" loading="lazy" width="480" height="640">' : '';
      const sale = p.compare && p.compare > p.price;
      let tag = '';
      if (p.available === false) tag = '<span class="bwp__tag">' + esc(L.sold) + '</span>';
      else if (sale) tag = '<span class="bwp__tag bwp__tag--sale">' + esc(L.sale) + '</span>';
      let add = '';
      if (p.withAdd) {
        if (p.available !== false && p.variantId) add = '<button type="button" class="bwp__add" data-bw-add="' + p.variantId + '"><span>' + esc(L.add) + '</span></button>';
        else if (p.available !== false) add = '<a href="' + esc(p.url) + '" class="bwp__add"><span>' + esc(L.options) + '</span></a>';
      }
      return '<div class="bwp bws__stagger" style="--i:' + (p.i || 0) + '">' +
        '<a href="' + esc(p.url) + '" class="bwp__media" tabindex="-1" aria-hidden="true">' + img + tag + '</a>' +
        '<div class="bwp__info"><a href="' + esc(p.url) + '" class="bwp__title" data-bws-item>' + (p.titleHtml || esc(p.title)) + '</a>' +
        '<span class="bwp__price">' + (sale ? '<s>' + money(p.compare, fmtStr) + '</s>' : '') + '<span>' + money(p.price, fmtStr) + '</span></span>' + add + '</div></div>';
    };
    return { root, esc, money, sized, config, portal, lock, trap, onUnload, card };
  })();

  /* ---------- Dawn sticky header (kept, adapted to transparent mode) ---------- */
  if (!customElements.get('sticky-header')) {
    class StickyHeader extends HTMLElement {
      connectedCallback() {
        this.header = document.querySelector('.section-header');
        if (!this.header) return;
        this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
        this.headerBounds = {};
        this.setHeaderHeight();
        this.onMq = this.setHeaderHeight.bind(this);
        window.matchMedia('(max-width: 990px)').addEventListener('change', this.onMq);
        if (window.ResizeObserver) { this.ro = new ResizeObserver(() => this.setHeaderHeight()); this.ro.observe(this); }
        if (this.headerIsAlwaysSticky) this.header.classList.add('shopify-section-header-sticky');
        this.currentScrollTop = 0;
        this.preventReveal = false;
        this.onScrollHandler = this.onScroll.bind(this);
        this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
        this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.addEventListener('scroll', this.onScrollHandler, false);
        this.createObserver();
      }
      setHeaderHeight() { document.documentElement.style.setProperty('--header-height', this.offsetHeight + 'px'); }
      disconnectedCallback() {
        this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.removeEventListener('scroll', this.onScrollHandler);
        if (this.ro) this.ro.disconnect();
      }
      createObserver() {
        const observer = new IntersectionObserver((entries, obs) => { this.headerBounds = entries[0].intersectionRect; obs.disconnect(); });
        observer.observe(this);
      }
      onScroll() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        if (document.documentElement.classList.contains('bwm-lock')) return;
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          this.header.classList.add('scrolled-past-header');
          if (this.preventHide) return;
          requestAnimationFrame(this.hide.bind(this));
        } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          this.header.classList.add('scrolled-past-header');
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          } else {
            window.clearTimeout(this.isScrolling);
            this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
            requestAnimationFrame(this.hide.bind(this));
          }
        } else if (scrollTop <= this.headerBounds.top) {
          this.header.classList.remove('scrolled-past-header');
          requestAnimationFrame(this.reset.bind(this));
        }
        this.currentScrollTop = scrollTop;
      }
      hide() {
        if (this.headerIsAlwaysSticky) return;
        this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
        this.header.querySelectorAll('bw-header-nav').forEach((n) => n.close && n.close(true));
        const dm = this.header.querySelector('details-modal');
        if (dm && dm.close) dm.close(false);
      }
      reveal() {
        if (this.headerIsAlwaysSticky) return;
        this.header.classList.add('shopify-section-header-sticky', 'animate');
        this.header.classList.remove('shopify-section-header-hidden');
      }
      reset() {
        if (this.headerIsAlwaysSticky) return;
        this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      }
    }
    customElements.define('sticky-header', StickyHeader);
  }

  /* ---------- Global click delegation: search open, carousels, quick add ---------- */
  if (!window.__bwhDelegates) {
    window.__bwhDelegates = true;

    document.addEventListener('click', (e) => {
      const t = e.target.closest && e.target.closest('[data-bws-open]');
      if (!t) return;
      const s = document.querySelector('bw-search.bws');
      if (s && s.open) { e.preventDefault(); s.open(t); }
    });

    document.addEventListener('keydown', (e) => {
      const tag = (e.target && e.target.tagName) || '';
      const typing = /INPUT|TEXTAREA|SELECT/.test(tag) || (e.target && e.target.isContentEditable);
      if (((e.key === '/' && !typing) || (e.key.toLowerCase() === 'k' && (e.metaKey || e.ctrlKey)))) {
        const s = document.querySelector('bw-search.bws');
        if (s && s.open) { e.preventDefault(); s.open(); }
      }
    });

    document.addEventListener('click', (e) => {
      const b = e.target.closest && e.target.closest('[data-car-prev], [data-car-next]');
      if (!b) return;
      const box = b.closest('.bwh__pblock, .bwc__recs, [data-car-scope]');
      const track = box && box.querySelector('[data-car-track]');
      if (!track) return;
      const dir = b.hasAttribute('data-car-next') ? 1 : -1;
      track.scrollBy({ left: dir * track.clientWidth * 0.85, behavior: 'smooth' });
    });

    document.addEventListener('click', async (e) => {
      const btn = e.target.closest && e.target.closest('[data-bw-add]');
      if (!btn || btn.classList.contains('is-loading')) return;
      e.preventDefault();
      btn.classList.add('is-loading');
      try {
        const res = await fetch(BW.root() + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(btn.dataset.bwAdd), quantity: 1 }] })
        });
        const data = await res.json();
        if (!res.ok || data.status) throw new Error(data.description || data.message || 'Error');
        btn.classList.add('is-added');
        setTimeout(() => btn.classList.remove('is-added'), 1600);
        document.querySelectorAll('bw-header-nav').forEach((n) => n.close && n.close(true));
        const search = document.querySelector('bw-search.bws.is-open');
        if (search) search.close(true);
        if (window.BWCart) { await window.BWCart.refresh(); window.BWCart.open(btn); }
        else window.location.href = BW.root() + 'cart';
      } catch (err) {
        btn.setAttribute('title', err.message);
        btn.animate([{ transform: 'translateX(0)' }, { transform: 'translateX(-4px)' }, { transform: 'translateX(4px)' }, { transform: 'translateX(0)' }], { duration: 300 });
      } finally {
        btn.classList.remove('is-loading');
      }
    });
  }

  /* ---------- Mega menu ---------- */
  if (!customElements.get('bw-header-nav')) {
    class BWHeaderNav extends HTMLElement {
      connectedCallback() {
        this.items = Array.from(this.querySelectorAll('[data-item]'));
        this.links = Array.from(this.querySelectorAll('.bwh__link'));
        this.menu = this.querySelector('.bwh__menu');
        this.glide = this.querySelector('.bwh__glide');
        this.wrapper = this.closest('.header-wrapper');
        this.overlay = this.wrapper && this.wrapper.querySelector('[data-bwh-overlay]');
        this.mode = this.dataset.openOn || 'hover';
        this.delay = parseInt(this.dataset.delay, 10) || 0;
        this.current = null;

        this.items.forEach((item) => {
          const trigger = item.querySelector('[data-trigger]');
          item.addEventListener('pointerenter', (e) => { if (e.pointerType === 'mouse' && this.mode === 'hover') this.scheduleOpen(item); });
          item.addEventListener('pointerleave', (e) => { if (e.pointerType === 'mouse' && this.mode === 'hover') this.scheduleClose(); });
          if (!trigger) return;
          trigger.addEventListener('pointerdown', (e) => { this.lastPointer = e.pointerType; });
          trigger.addEventListener('click', (e) => this.onTriggerClick(e, item));
        });

        this.addEventListener('keydown', (e) => this.onKeydown(e));
        this.addEventListener('focusout', (e) => { if (this.current && !this.contains(e.relatedTarget)) this.close(); });

        /* Hover image preview inside panels */
        this.onPreview = (e) => {
          const a = e.target.closest && e.target.closest('[data-preview]');
          if (a && this.contains(a)) this.preview(a);
        };
        this.addEventListener('pointerover', this.onPreview);
        this.addEventListener('focusin', this.onPreview);

        /* Gliding underline */
        if (this.glide) {
          this.home = () => this.querySelector('.bwh__link.is-active');
          this.target = null;
          this.links.forEach((l) => {
            l.addEventListener('pointerenter', () => this.moveGlide(l));
            l.addEventListener('focus', () => this.moveGlide(l));
          });
          this.menu.addEventListener('pointerleave', () => {
            setTimeout(() => { if (!this.menu.matches(':hover')) this.moveGlide(this.current ? this.current.querySelector('.bwh__link') : this.home()); }, 60);
          });
          if (window.ResizeObserver) { this.ro = new ResizeObserver(() => this.moveGlide(this.target, true)); this.ro.observe(this); }
          if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => this.moveGlide(this.home(), true));
          requestAnimationFrame(() => this.moveGlide(this.home(), true));
        }

        if (this.overlay) {
          this.onOverlay = () => this.close();
          this.overlay.addEventListener('click', this.onOverlay);
          this.overlay.addEventListener('pointerenter', this.onOverlay);
        }
        this.onDocClick = (e) => { if (this.current && !this.contains(e.target)) this.close(); };
        document.addEventListener('click', this.onDocClick);
        this.onScroll = () => { if (this.current && Math.abs(window.scrollY - this.openScroll) > 80) this.close(); };
        window.addEventListener('scroll', this.onScroll, { passive: true });
        this.mqs = [window.matchMedia('(max-width: 749px)'), window.matchMedia('(max-width: 989px)')];
        this.onMq = () => this.close(true);
        this.mqs.forEach((m) => m.addEventListener('change', this.onMq));
        this.onBlockSelect = (e) => {
          const t = e.target;
          if (!t || !t.closest) return;
          const item = t.closest('[data-item]');
          if (item && this.contains(item)) this.open(item);
        };
        this.onBlockDeselect = (e) => { if (e.target && e.target.closest && this.contains(e.target)) this.close(); };
        document.addEventListener('shopify:block:select', this.onBlockSelect);
        document.addEventListener('shopify:block:deselect', this.onBlockDeselect);
      }

      disconnectedCallback() {
        document.removeEventListener('click', this.onDocClick);
        window.removeEventListener('scroll', this.onScroll);
        if (this.mqs) this.mqs.forEach((m) => m.removeEventListener('change', this.onMq));
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
        document.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
        if (this.ro) this.ro.disconnect();
        if (this.wrapper) this.wrapper.classList.remove('bwh-menu-open');
      }

      moveGlide(link, instant) {
        const g = this.glide;
        if (!g) return;
        this.target = link || null;
        const label = link && link.querySelector('.bwh__label');
        if (!label || !label.offsetWidth) { g.style.opacity = '0'; return; }
        const host = g.offsetParent || this;
        const n = host.getBoundingClientRect();
        const r = label.getBoundingClientRect();
        if (instant) g.style.transition = 'none';
        g.style.width = r.width + 'px';
        g.style.transform = 'translate3d(' + (r.left - n.left) + 'px,' + (r.bottom - n.top + 6) + 'px,0)';
        g.style.opacity = '1';
        if (instant) { void g.offsetWidth; g.style.transition = ''; }
      }

      preview(a) {
        const box = a.closest('[data-panel]') && a.closest('[data-panel]').querySelector('[data-preview-box]');
        if (!box) return;
        const url = a.dataset.preview;
        const imgs = box.querySelectorAll('.bwh__preview-img');
        const front = box.querySelector('.bwh__preview-img.is-front') || imgs[0];
        const back = imgs[0] === front ? imgs[1] : imgs[0];
        const cap = box.querySelector('[data-preview-cap]');
        if (!back || box.dataset.current === url) return;
        box.dataset.current = url;
        const swap = () => {
          if (box.dataset.current !== url) return;
          back.classList.add('is-front');
          front.classList.remove('is-front');
          if (cap) {
            cap.classList.add('is-swapping');
            setTimeout(() => { cap.textContent = a.dataset.label || ''; cap.classList.remove('is-swapping'); }, 180);
          }
        };
        back.removeAttribute('srcset');
        back.onload = swap;
        back.src = url;
        if (back.complete && back.naturalWidth > 1) swap();
      }

      scheduleOpen(item) {
        clearTimeout(this.closeTimer);
        clearTimeout(this.openTimer);
        if (this.current === item) return;
        const wait = this.current ? 0 : this.delay;
        this.openTimer = setTimeout(() => this.open(item), wait);
      }
      scheduleClose() {
        clearTimeout(this.openTimer);
        clearTimeout(this.closeTimer);
        this.closeTimer = setTimeout(() => this.close(), 200);
      }
      isPhone() { return window.matchMedia('(max-width: 749px)').matches; }
      onTriggerClick(e, item) {
        if (this.isPhone()) return;
        const tapToOpen = this.mode === 'click' || this.lastPointer === 'touch' || this.lastPointer === 'pen';
        this.lastPointer = null;
        if (tapToOpen && this.current !== item) { e.preventDefault(); this.open(item); }
      }
      onKeydown(e) {
        if (e.key === 'Escape' && this.current) {
          const trigger = this.current.querySelector('[data-trigger]');
          this.close();
          if (trigger) trigger.focus();
          return;
        }
        const link = e.target.closest('.bwh__link');
        if (!link) return;
        const item = link.closest('[data-item]');
        if (item && (e.key === 'ArrowDown' || e.key === ' ')) {
          e.preventDefault();
          this.open(item);
          const first = item.querySelector('[data-panel] a');
          if (first) requestAnimationFrame(() => first.focus());
        } else if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
          e.preventDefault();
          const i = this.links.indexOf(link);
          const next = this.links[(i + (e.key === 'ArrowRight' ? 1 : -1) + this.links.length) % this.links.length];
          if (this.current) this.close(true);
          next.focus();
        }
      }
      setState(item, open) {
        const trigger = item.querySelector('[data-trigger]');
        const panel = item.querySelector('[data-panel]');
        if (trigger) trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (panel) panel.classList.toggle('is-open', open);
      }
      open(item) {
        if (this.isPhone()) return;
        clearTimeout(this.closeTimer);
        clearTimeout(this.openTimer);
        if (this.current === item) return;
        const switching = !!this.current;
        if (switching) { this.classList.add('is-instant'); this.setState(this.current, false); }
        this.setState(item, true);
        this.current = item;
        this.openScroll = window.scrollY;
        this.classList.add('has-open');
        if (this.wrapper) this.wrapper.classList.add('bwh-menu-open');
        if (this.glide) this.moveGlide(item.querySelector('.bwh__link'));
        if (switching) requestAnimationFrame(() => requestAnimationFrame(() => this.classList.remove('is-instant')));
      }
      close(immediate) {
        clearTimeout(this.openTimer);
        clearTimeout(this.closeTimer);
        if (!this.current) return;
        if (immediate) this.classList.add('is-instant');
        this.setState(this.current, false);
        this.current = null;
        this.classList.remove('has-open');
        if (this.wrapper) this.wrapper.classList.remove('bwh-menu-open');
        if (this.glide && !this.menu.matches(':hover')) this.moveGlide(this.home());
        if (immediate) requestAnimationFrame(() => requestAnimationFrame(() => this.classList.remove('is-instant')));
      }
    }
    customElements.define('bw-header-nav', BWHeaderNav);
  }

  /* ---------- Brand icons for Dawn's search snippet, and the cart icon after Dawn re-renders it ---------- */
  if (!customElements.get('bw-header-icons')) {
    class BWHeaderIcons extends HTMLElement {
      connectedCallback() {
        this.wrap = this.closest('.bwh');
        if (!this.wrap) return;
        const tpl = (name) => { const t = this.querySelector('template[data-icon="' + name + '"]'); return t ? t.innerHTML.trim() : ''; };
        this.searchSvg = tpl('search');
        this.bagSvg = tpl('bag');
        this.wrap.querySelectorAll('.header__icon--search .svg-wrapper:not(.header__icon-close)').forEach((w) => {
          if (this.searchSvg && !w.querySelector('.bwh-ic')) w.innerHTML = this.searchSvg;
        });
        this.cart = this.wrap.querySelector('#cart-icon-bubble');
        this.swapCart();
        if (this.cart && window.MutationObserver) {
          this.mo = new MutationObserver(() => this.swapCart());
          this.mo.observe(this.cart, { childList: true });
        }
      }
      disconnectedCallback() { if (this.mo) this.mo.disconnect(); }
      swapCart() {
        if (!this.cart || !this.bagSvg) return;
        const w = this.cart.querySelector('.svg-wrapper');
        if (w && !w.querySelector('.bwh-ic')) w.innerHTML = this.bagSvg;
      }
    }
    customElements.define('bw-header-icons', BWHeaderIcons);
  }

  /* ---------- Transparent header: clear at the top of the home page ---------- */
  if (!customElements.get('bw-header-clear')) {
    class BWHeaderClear extends HTMLElement {
      connectedCallback() {
        this.wrap = this.closest('.bwh');
        if (!this.wrap) return;
        this.hover = false;
        this.focus = false;
        this.update = () => {
          const clear = window.scrollY < 8 && !this.hover && !this.focus &&
            !this.wrap.classList.contains('bwh-menu-open') && !this.wrap.classList.contains('is-condensed');
          this.wrap.classList.toggle('is-clear', clear);
        };
        this.onScroll = () => { if (!this.raf) this.raf = requestAnimationFrame(() => { this.raf = null; this.update(); }); };
        this.onEnter = (e) => { if (e.pointerType === 'mouse') { this.hover = true; this.update(); } };
        this.onLeave = () => { this.hover = false; this.update(); };
        this.onFocusIn = () => { this.focus = true; this.update(); };
        this.onFocusOut = (e) => { if (!this.wrap.contains(e.relatedTarget)) { this.focus = false; this.update(); } };
        window.addEventListener('scroll', this.onScroll, { passive: true });
        this.wrap.addEventListener('pointerenter', this.onEnter);
        this.wrap.addEventListener('pointerleave', this.onLeave);
        this.wrap.addEventListener('focusin', this.onFocusIn);
        this.wrap.addEventListener('focusout', this.onFocusOut);
        this.mo = new MutationObserver(this.update);
        this.mo.observe(this.wrap, { attributes: true, attributeFilter: ['class'] });
        this.update();
      }
      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
        if (this.mo) this.mo.disconnect();
        if (this.wrap) {
          this.wrap.removeEventListener('pointerenter', this.onEnter);
          this.wrap.removeEventListener('pointerleave', this.onLeave);
          this.wrap.removeEventListener('focusin', this.onFocusIn);
          this.wrap.removeEventListener('focusout', this.onFocusOut);
        }
      }
    }
    customElements.define('bw-header-clear', BWHeaderClear);
  }

  /* ---------- Fold-up header on scroll ---------- */
  if (!customElements.get('bw-header-scroll')) {
    class BWHeaderScroll extends HTMLElement {
      connectedCallback() {
        this.wrap = this.closest('.bwh');
        this.section = this.closest('.section-header');
        if (!this.wrap || !this.section) return;
        this.mode = this.wrap.dataset.condense || 'fold';
        this.condensed = false;
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.spacer = document.createElement('div');
        this.spacer.className = 'bwh-spacer';
        this.spacer.setAttribute('aria-hidden', 'true');
        this.spacer.style.height = '0px';
        this.section.after(this.spacer);
        this.onScroll = () => {
          if (this.raf) return;
          this.raf = requestAnimationFrame(() => { this.raf = null; this.check(); });
        };
        this.onResize = () => {
          if (this.condensed) { this.set(false, true); this.measure(); this.check(); } else { this.measure(); }
        };
        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onResize);
        this.measure();
        this.check();
      }
      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onResize);
        if (this.spacer) this.spacer.remove();
        if (this.section) this.section.classList.remove('bwh-fixed');
      }
      measure() {
        this.expandedH = this.wrap.offsetHeight;
        this.flowH = this.section.offsetHeight;
        this.start = this.section.getBoundingClientRect().top + window.scrollY;
        if (this.section.classList.contains('shopify-section-header-sticky')) {
          this.start = Math.max(0, this.spacer.getBoundingClientRect().top + window.scrollY - this.flowH);
        }
      }
      check() {
        if (document.documentElement.classList.contains('bwm-lock')) return;
        const y = window.scrollY;
        const enter = this.start + this.expandedH + 24;
        const leave = this.start + Math.max(this.expandedH - 24, 8);
        if (!this.condensed && y > enter) this.set(true);
        else if (this.condensed && y < leave) this.set(false);
      }
      targets() {
        return [this.wrap.querySelector('.bwh__brand .bwh__logo-link'), this.wrap.querySelector('.bwh__menu'), this.wrap.querySelector('.bwh__icons')].filter(Boolean);
      }
      set(on, instant) {
        const nav = this.wrap.querySelector('bw-header-nav');
        if (nav && nav.close) nav.close(true);
        const device = window.matchMedia('(min-width: 990px)').matches ? 'desktop' : window.matchMedia('(min-width: 750px)').matches ? 'tablet' : 'mobile';
        const layout = this.wrap.dataset['layout' + device.charAt(0).toUpperCase() + device.slice(1)];
        const flip = !instant && !this.reduced && this.mode === 'fold' && device !== 'mobile' && (layout === 'center' || layout === 'left_below');
        const els = flip ? this.targets() : [];
        const first = els.map((el) => el.getBoundingClientRect());
        const firstH = this.wrap.getBoundingClientRect().height;
        if (flip) this.wrap.classList.add('is-flipping');
        if (on) {
          this.spacer.style.height = this.flowH + 'px';
          this.section.classList.add('bwh-fixed');
          this.wrap.classList.add('is-condensed');
        } else {
          this.wrap.classList.remove('is-condensed');
          this.section.classList.remove('bwh-fixed');
          this.spacer.style.height = '0px';
        }
        this.condensed = on;
        document.documentElement.style.setProperty('--bwh-condensed-h', this.wrap.offsetHeight + 'px');
        if (!flip) return;
        const ease = 'cubic-bezier(0.2, 0.7, 0.2, 1)';
        const dur = 650;
        els.forEach((el, i) => {
          const last = el.getBoundingClientRect();
          const f = first[i];
          const dx = f.left - last.left;
          const dy = f.top - last.top;
          const sc = last.width ? f.width / last.width : 1;
          if (Math.abs(dx) < 1 && Math.abs(dy) < 1 && Math.abs(sc - 1) < 0.01) return;
          el.animate([{ transformOrigin: '0 0', transform: 'translate(' + dx + 'px, ' + dy + 'px) scale(' + sc + ')' }, { transformOrigin: '0 0', transform: 'none' }], { duration: dur, easing: ease });
        });
        const lastH = this.wrap.getBoundingClientRect().height;
        this.wrap.style.overflow = 'hidden';
        const anim = this.wrap.animate([{ height: firstH + 'px' }, { height: lastH + 'px' }], { duration: dur, easing: ease });
        const fade = this.wrap.querySelectorAll('.bwh__tagline, .bwh__navcell');
        if (!on) fade.forEach((el) => el.animate([{ opacity: 0 }, { opacity: 1 }], { duration: dur, easing: 'ease' }));
        const done = () => { this.wrap.style.overflow = ''; };
        anim.onfinish = done;
        anim.oncancel = done;
        requestAnimationFrame(() => requestAnimationFrame(() => this.wrap.classList.remove('is-flipping')));
      }
    }
    customElements.define('bw-header-scroll', BWHeaderScroll);
  }

  /* ---------- Slide-out menu with images ---------- */
  if (!customElements.get('bw-mobile-menu')) {
    class BWMobileMenu extends HTMLElement {
      connectedCallback() {
        if (BW.portal(this)) return;
        if (this.ready) return;
        this.ready = true;
        this.offUnload = BW.onUnload(this);
        this.panel = this.querySelector('.bwm__panel');
        this.root = this.querySelector('[data-level="root"]');
        this.stack = [];
        this.opener = document.querySelector('[data-bwm-open][aria-controls="' + this.id + '"]');
        this.onOpenClick = (e) => { e.preventDefault(); this.isOpen ? this.close() : this.open(); };
        if (this.opener) this.opener.addEventListener('click', this.onOpenClick);
        this.addEventListener('click', (e) => {
          if (e.target.closest('[data-bwm-close]')) { this.close(); return; }
          const go = e.target.closest('[data-bwm-go]');
          if (go) { this.go(go.dataset.bwmGo, go); return; }
          if (e.target.closest('[data-bwm-back]')) { this.back(); return; }
          if (e.target.closest('[data-bwm-search]')) {
            this.close(true);
            const bs = document.querySelector('bw-search.bws');
            const wrap = document.querySelector('#shopify-section-' + CSS.escape(this.dataset.sectionId) + ' .bwh');
            const summary = wrap && wrap.querySelector('details-modal.header__search summary');
            setTimeout(() => { if (bs && bs.open) bs.open(); else if (summary) summary.click(); }, 60);
          }
        });
        this.addEventListener('keydown', (e) => {
          if (e.key === 'Escape') { e.preventDefault(); this.stack.length ? this.back() : this.close(); }
          if (e.key === 'Tab') BW.trap(e, this.panel);
        });
        this.mqs = [window.matchMedia('(max-width: 749px)'), window.matchMedia('(max-width: 989px)')];
        this.onMq = () => { if (this.isOpen) this.close(true); };
        this.mqs.forEach((m) => m.addEventListener('change', this.onMq));
      }
      disconnectedCallback() {
        if (!this.ready) return;
        this.ready = false;
        if (this.offUnload) this.offUnload();
        if (this.opener) this.opener.removeEventListener('click', this.onOpenClick);
        if (this.mqs) this.mqs.forEach((m) => m.removeEventListener('change', this.onMq));
        if (this.isOpen) BW.lock(false);
      }
      open() {
        this.isOpen = true;
        this.reset();
        this.classList.add('is-open');
        BW.lock(true);
        if (this.opener) this.opener.setAttribute('aria-expanded', 'true');
        const close = this.querySelector('.bwm__close');
        setTimeout(() => (close || this.panel).focus({ preventScroll: true }), 80);
      }
      close(instant) {
        if (!this.isOpen) return;
        this.isOpen = false;
        this.classList.remove('is-open');
        BW.lock(false);
        if (this.opener) {
          this.opener.setAttribute('aria-expanded', 'false');
          if (!instant) this.opener.focus({ preventScroll: true });
        }
        clearTimeout(this.resetTimer);
        this.resetTimer = setTimeout(() => { if (!this.isOpen) this.reset(); }, instant ? 0 : 650);
      }
      reset() {
        this.stack = [];
        this.querySelectorAll('.bwm__level').forEach((l) => { l.classList.toggle('is-active', l === this.root); l.classList.remove('is-past'); l.scrollTop = 0; });
        this.querySelectorAll('[data-bwm-go]').forEach((b) => b.setAttribute('aria-expanded', 'false'));
      }
      current() { return this.stack.length ? this.stack[this.stack.length - 1].level : this.root; }
      go(id, btn) {
        const next = document.getElementById(id);
        if (!next) return;
        const cur = this.current();
        cur.classList.remove('is-active');
        cur.classList.add('is-past');
        next.classList.remove('is-past');
        next.scrollTop = 0;
        void next.offsetWidth;
        next.classList.add('is-active');
        if (btn) btn.setAttribute('aria-expanded', 'true');
        this.stack.push({ level: next, btn: btn });
        const back = next.querySelector('[data-bwm-back]');
        if (back) setTimeout(() => back.focus({ preventScroll: true }), 120);
      }
      back() {
        const top = this.stack.pop();
        if (!top) return;
        top.level.classList.remove('is-active');
        const prev = this.current();
        prev.classList.remove('is-past');
        void prev.offsetWidth;
        prev.classList.add('is-active');
        if (top.btn) { top.btn.setAttribute('aria-expanded', 'false'); setTimeout(() => top.btn.focus({ preventScroll: true }), 120); }
      }
    }
    customElements.define('bw-mobile-menu', BWMobileMenu);
  }

  /* ---------- Luxury search overlay with predictive results ---------- */
  if (!customElements.get('bw-search')) {
    class BWSearch extends HTMLElement {
      connectedCallback() {
        if (BW.portal(this)) return;
        if (this.ready) return;
        this.ready = true;
        this.offUnload = BW.onUnload(this);
        this.cfg = BW.config(this.dataset.sectionId);
        this.L = this.cfg.labels || {};
        this.panel = this.querySelector('.bws__panel');
        this.form = this.querySelector('form');
        this.input = this.querySelector('[data-bws-input]');
        this.idle = this.querySelector('[data-bws-idle]');
        this.results = this.querySelector('[data-bws-results]');
        this.clearBtn = this.querySelector('[data-bws-clear]');
        this.recentBox = this.querySelector('[data-bws-recent]');
        this.cache = new Map();

        this.onInput = () => {
          const q = this.input.value.trim();
          this.clearBtn.hidden = !q;
          clearTimeout(this.timer);
          this.timer = setTimeout(() => this.search(q), q ? 180 : 0);
        };
        this.input.addEventListener('input', this.onInput);
        this.form.addEventListener('submit', (e) => {
          const q = this.input.value.trim();
          const active = this.querySelector('[data-bws-item].is-focus');
          if (active) { e.preventDefault(); if (q) this.remember(q); active.click(); return; }
          if (!q) { e.preventDefault(); return; }
          this.remember(q);
        });
        this.addEventListener('click', (e) => {
          if (e.target.closest('[data-bws-close]')) { this.close(); return; }
          if (e.target.closest('[data-bws-clear]')) { this.input.value = ''; this.onInput(); this.input.focus(); return; }
          if (e.target.closest('[data-bws-forget]')) { this.forget(); return; }
          const term = e.target.closest('[data-bws-term]');
          if (term) { e.preventDefault(); this.input.value = term.dataset.bwsTerm; this.onInput(); this.input.focus(); return; }
          const item = e.target.closest('a[data-bws-item], a.bwp__media');
          if (item && this.input.value.trim()) this.remember(this.input.value.trim());
        });
        this.addEventListener('keydown', (e) => {
          if (e.key === 'Escape') { e.preventDefault(); this.close(); return; }
          if (e.key === 'Tab') BW.trap(e, this.panel);
          if (e.key === 'ArrowDown' || e.key === 'ArrowUp') { e.preventDefault(); this.move(e.key === 'ArrowDown' ? 1 : -1); }
        });
        this.renderRecent();
      }
      disconnectedCallback() {
        if (!this.ready) return;
        this.ready = false;
        if (this.offUnload) this.offUnload();
        if (this.isOpen) BW.lock(false);
      }
      open(opener) {
        if (this.isOpen) return;
        this.isOpen = true;
        this.opener = opener || document.activeElement;
        this.renderRecent();
        this.classList.add('is-open');
        BW.lock(true);
        document.querySelectorAll('[data-bws-open]').forEach((b) => b.setAttribute('aria-expanded', 'true'));
        setTimeout(() => { this.input.focus({ preventScroll: true }); if (this.input.value) this.input.select(); }, 160);
      }
      close(silent) {
        if (!this.isOpen) return;
        this.isOpen = false;
        this.classList.remove('is-open');
        BW.lock(false);
        document.querySelectorAll('[data-bws-open]').forEach((b) => b.setAttribute('aria-expanded', 'false'));
        if (!silent && this.opener && this.opener.focus) this.opener.focus({ preventScroll: true });
      }
      items() {
        const scope = this.results.hidden ? this.idle : this.results;
        return Array.from(scope.querySelectorAll('[data-bws-item], [data-bws-term]')).filter((el) => el.offsetParent !== null);
      }
      move(dir) {
        const list = this.items();
        if (!list.length) return;
        const cur = list.findIndex((el) => el.classList.contains('is-focus'));
        list.forEach((el) => el.classList.remove('is-focus'));
        const next = cur === -1 ? (dir > 0 ? 0 : list.length - 1) : (cur + dir + list.length) % list.length;
        list[next].classList.add('is-focus');
        list[next].scrollIntoView({ block: 'nearest' });
      }
      readRecent() { try { return JSON.parse(localStorage.getItem('bwRecentSearches') || '[]'); } catch (e) { return []; } }
      remember(q) {
        if (!this.cfg.showRecent) return;
        const list = [q].concat(this.readRecent().filter((x) => x.toLowerCase() !== q.toLowerCase())).slice(0, 6);
        try { localStorage.setItem('bwRecentSearches', JSON.stringify(list)); } catch (e) {}
      }
      forget() { try { localStorage.removeItem('bwRecentSearches'); } catch (e) {} this.renderRecent(); }
      renderRecent() {
        if (!this.recentBox) return;
        const list = this.readRecent();
        this.recentBox.hidden = !list.length;
        const box = this.recentBox.querySelector('[data-bws-recent-list]');
        if (box) box.innerHTML = list.map((t) => '<button type="button" class="bws__chip" data-bws-term="' + BW.esc(t) + '">' + BW.esc(t) + '</button>').join('');
      }
      async search(q) {
        if (this.ctrl) this.ctrl.abort();
        if (!q) { this.results.hidden = true; this.results.innerHTML = ''; this.idle.hidden = false; this.classList.remove('is-loading'); return; }
        if (this.cache.has(q)) { this.render(q, this.cache.get(q)); return; }
        this.ctrl = new AbortController();
        this.classList.add('is-loading');
        const limit = Math.max(2, Math.min(10, this.cfg.searchLimit || 8));
        const url = BW.root() + 'search/suggest.json?q=' + encodeURIComponent(q) +
          '&resources[type]=product,collection,page,query&resources[limit]=' + limit +
          '&resources[limit_scope]=each&resources[options][unavailable_products]=last';
        try {
          const res = await fetch(url, { signal: this.ctrl.signal, headers: { Accept: 'application/json' } });
          const data = await res.json();
          this.cache.set(q, data);
          if (this.input.value.trim() === q) this.render(q, data);
        } catch (e) {
          if (e.name !== 'AbortError') this.classList.remove('is-loading');
        }
      }
      render(q, data) {
        this.classList.remove('is-loading');
        const L = this.L;
        const esc = BW.esc;
        const r = (data && data.resources && data.resources.results) || {};
        const products = r.products || [];
        const cols = r.collections || [];
        const pages = r.pages || [];
        const queries = (r.queries || []).filter((x) => (x.text || '').toLowerCase() !== q.toLowerCase());
        const re = new RegExp('(' + q.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + ')', 'ig');
        const hl = (t) => esc(t).replace(re, '<mark>$1</mark>');
        const allUrl = BW.root() + 'search?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last';
        const arrow = '<svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true"><path d="M5 12h14M13.5 6.5L19 12l-5.5 5.5" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        let i = 0;
        let html;
        if (!products.length && !cols.length && !pages.length && !queries.length) {
          html = '<div class="bws__empty bws__stagger" style="--i:0"><p class="bws__empty-title">' + esc((L.noResults || 'No results for "[query]"').replace('[query]', q)) + '</p>' +
            '<a class="bws__all" href="' + esc(allUrl) + '" data-bws-item><span>' + esc(L.viewAll) + '</span>' + arrow + '</a></div>';
        } else {
          let side = '';
          const group = (title, rows) => '<div class="bws__group bws__stagger" style="--i:' + (i++) + '"><p class="bws__label"><span>' + esc(title) + '</span></p><div>' + rows + '</div></div>';
          if (queries.length) side += group(L.suggestions, queries.map((x) => '<a class="bws__sugg" href="' + esc(x.url) + '" data-bws-item>' + (x.styled_text || esc(x.text)) + '</a>').join(''));
          if (cols.length) side += group(L.collections, cols.map((c) => {
            const im = c.featured_image && c.featured_image.url;
            return '<a class="bws__row" href="' + esc(c.url) + '" data-bws-item>' + (im ? '<span class="bws__thumb"><img src="' + esc(BW.sized(im, 120)) + '" alt="" loading="lazy"></span>' : '') + '<span class="bws__row-text">' + hl(c.title) + '</span>' + arrow + '</a>';
          }).join(''));
          if (pages.length) side += group(L.pages, pages.map((p) => '<a class="bws__row" href="' + esc(p.url) + '" data-bws-item><span class="bws__row-text">' + hl(p.title) + '</span>' + arrow + '</a>').join(''));
          let main = '';
          if (products.length) {
            main = '<div class="bws__main"><p class="bws__label bws__stagger" style="--i:' + (i++) + '"><span>' + esc(L.products) + '</span><a class="bws__more" href="' + esc(allUrl) + '">' + esc(L.viewAll) + '</a></p><div class="bws__products">' +
              products.map((p, n) => {
                const img = (p.featured_image && p.featured_image.url) || p.image || '';
                return BW.card({
                  title: p.title, titleHtml: hl(p.title), url: p.url, image: img,
                  price: Math.round(parseFloat(p.price || p.price_min || 0) * 100),
                  compare: Math.round(parseFloat(p.compare_at_price_max || 0) * 100),
                  available: p.available, i: i + n
                }, L, this.cfg.moneyFormat);
              }).join('') + '</div></div>';
          }
          html = '<div class="bws__grid"><div class="bws__aside">' + side + '</div>' + main + '</div>' +
            '<a class="bws__all bws__stagger" style="--i:' + (i + products.length) + '" href="' + esc(allUrl) + '" data-bws-item><span>' + esc(L.viewAll) + ' &ldquo;' + esc(q) + '&rdquo;</span>' + arrow + '</a>';
        }
        this.results.classList.remove('is-fresh');
        this.results.innerHTML = html;
        void this.results.offsetWidth;
        this.results.classList.add('is-fresh');
        this.results.hidden = false;
        this.idle.hidden = true;
      }
    }
    customElements.define('bw-search', BWSearch);
  }

  /* ---------- Luxury cart drawer ---------- */
  if (!customElements.get('bw-cart-drawer')) {
    class BWCartDrawer extends HTMLElement {
      connectedCallback() {
        if (BW.portal(this)) return;
        if (this.ready) return;
        this.ready = true;
        this.offUnload = BW.onUnload(this);
        this.cfg = BW.config(this.dataset.sectionId);
        this.L = this.cfg.labels || {};
        this.panel = this.querySelector('.bwc__panel');
        this.itemsEl = this.querySelector('[data-bwc-items]');
        this.emptyEl = this.querySelector('[data-bwc-empty]');
        this.footEl = this.querySelector('[data-bwc-foot]');
        this.countEl = this.querySelector('[data-bwc-count]');
        this.totalEl = this.querySelector('[data-bwc-total]');
        this.saveEl = this.querySelector('[data-bwc-save]');
        this.shipEl = this.querySelector('[data-bwc-ship]');
        this.recsEl = this.querySelector('[data-bwc-recs]');
        this.noteEl = this.querySelector('[data-bwc-note]');
        try { this.cart = JSON.parse(this.querySelector('[data-bwc-initial]').textContent); } catch (e) { this.cart = null; }
        if (this.cart) this.render();

        this.addEventListener('click', (e) => this.onClick(e));
        this.addEventListener('change', (e) => {
          const input = e.target.closest('[data-bwc-input]');
          if (!input) return;
          const line = input.closest('[data-key]');
          const q = Math.max(0, parseInt(input.value, 10) || 0);
          this.change(line.dataset.key, q, line);
        });
        this.addEventListener('keydown', (e) => {
          if (e.key === 'Escape') { e.preventDefault(); this.close(); }
          if (e.key === 'Tab') BW.trap(e, this.panel);
        });
        if (this.noteEl) {
          this.noteEl.addEventListener('input', () => {
            clearTimeout(this.noteTimer);
            this.noteTimer = setTimeout(() => {
              fetch(BW.root() + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ note: this.noteEl.value }) });
            }, 500);
          });
        }
        this.querySelector('.bwc__actions').addEventListener('submit', () => {
          const b = this.querySelector('.bwc__checkout');
          if (b) b.classList.add('is-loading');
        });

        /* Open from the header bag icon. Capture phase so Dawn's own drawer does not also open. */
        this.onIconClick = (e) => {
          const t = e.target.closest && e.target.closest('[data-bwc-open]');
          if (!t) return;
          e.preventDefault();
          e.stopPropagation();
          this.open(t);
        };
        document.addEventListener('click', this.onIconClick, true);

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsub = subscribe(PUB_SUB_EVENTS.cartUpdate, (ev) => { if (!ev || ev.source !== 'bw-cart-drawer') this.refresh(); });
        }
        this.onRefreshEvt = () => this.refresh();
        document.addEventListener('cart:refresh', this.onRefreshEvt);
        window.BWCart = this;
      }
      disconnectedCallback() {
        if (!this.ready) return;
        this.ready = false;
        if (this.offUnload) this.offUnload();
        document.removeEventListener('click', this.onIconClick, true);
        document.removeEventListener('cart:refresh', this.onRefreshEvt);
        if (this.unsub) this.unsub();
        if (this.isOpen) BW.lock(false);
        if (window.BWCart === this) window.BWCart = null;
      }
      open(opener) {
        if (this.isOpen) return;
        this.isOpen = true;
        this.opener = opener || document.activeElement;
        this.classList.remove('is-settled');
        void this.offsetWidth;
        this.classList.add('is-open');
        BW.lock(true);
        clearTimeout(this.settleTimer);
        this.settleTimer = setTimeout(() => this.classList.add('is-settled'), 1300);
        setTimeout(() => { const c = this.querySelector('.bwc__close'); (c || this.panel).focus({ preventScroll: true }); }, 120);
        if (this.cart && this.cart.items.length) this.loadRecs();
      }
      close() {
        if (!this.isOpen) return;
        this.isOpen = false;
        this.classList.remove('is-open');
        BW.lock(false);
        if (this.opener && this.opener.focus) this.opener.focus({ preventScroll: true });
      }
      onClick(e) {
        if (e.target.closest('[data-bwc-close]')) { this.close(); return; }
        const step = e.target.closest('[data-bwc-qty]');
        if (step) {
          const line = step.closest('[data-key]');
          const input = line.querySelector('[data-bwc-input]');
          const q = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(step.dataset.bwcQty, 10));
          input.value = q;
          this.change(line.dataset.key, q, line);
          return;
        }
        const rm = e.target.closest('[data-bwc-remove]');
        if (rm) { const line = rm.closest('[data-key]'); this.change(line.dataset.key, 0, line); }
      }
      async refresh() {
        try {
          const res = await fetch(BW.root() + 'cart.js', { headers: { Accept: 'application/json' } });
          this.cart = await res.json();
          this.render();
          if (this.isOpen) this.loadRecs();
        } catch (e) {}
        return this.cart;
      }
      async change(key, quantity, line) {
        if (line) {
          line.classList.add('is-loading');
          const err = line.querySelector('[data-bwc-err]');
          if (err) err.textContent = '';
        }
        if (quantity === 0 && line) {
          line.style.maxHeight = line.offsetHeight + 'px';
          line.classList.add('is-removing');
        }
        try {
          const res = await fetch(BW.root() + 'cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: key, quantity: quantity })
          });
          const data = await res.json();
          if (!res.ok || data.status) {
            await this.refresh();
            const l = this.querySelector('[data-key="' + CSS.escape(key) + '"] [data-bwc-err]');
            if (l) l.textContent = data.description || data.message || '';
            return;
          }
          if (quantity === 0) await new Promise((r) => setTimeout(r, 300));
          this.cart = data;
          this.render();
          this.loadRecs();
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'bw-cart-drawer', cartData: data });
        } catch (e) {
          if (line) line.classList.remove('is-loading', 'is-removing');
        }
      }
      lineHTML(it, i) {
        const esc = BW.esc;
        const fmt = this.cfg.moneyFormat;
        const img = it.image ? '<img src="' + esc(BW.sized(it.image, 300)) + '" alt="' + esc(it.product_title) + '" loading="lazy" width="150" height="200">' : '';
        let meta = '';
        if (!it.product_has_only_default_variant && it.options_with_values) {
          meta += it.options_with_values.map((o) => '<p class="bwc__meta">' + esc(o.name) + ': ' + esc(o.value) + '</p>').join('');
        }
        if (it.selling_plan_allocation && it.selling_plan_allocation.selling_plan) meta += '<p class="bwc__meta">' + esc(it.selling_plan_allocation.selling_plan.name) + '</p>';
        Object.keys(it.properties || {}).forEach((k) => {
          const v = it.properties[k];
          if (!v || k.charAt(0) === '_') return;
          meta += '<p class="bwc__meta">' + esc(k) + ': ' + (String(v).indexOf('/uploads/') > -1 ? '<a href="' + esc(v) + '" target="_blank" rel="noopener">' + esc(String(v).split('/').pop()) + '</a>' : esc(v)) + '</p>';
        });
        (it.line_level_discount_allocations || []).forEach((d) => {
          meta += '<p class="bwc__meta bwc__disc">' + esc(d.discount_application.title) + ' (&minus;' + BW.money(d.amount, fmt) + ')</p>';
        });
        const price = (it.original_line_price > it.final_line_price ? '<s>' + BW.money(it.original_line_price, fmt) + '</s>' : '') + BW.money(it.final_line_price, fmt);
        return '<div class="bwc__line bwc__stagger" data-key="' + esc(it.key) + '" style="--i:' + i + '">' +
          '<a class="bwc__thumb" href="' + esc(it.url) + '">' + img + '</a>' +
          '<div class="bwc__info">' +
            '<div class="bwc__row"><a class="bwc__name" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a><span class="bwc__price">' + price + '</span></div>' +
            meta +
            '<div class="bwc__row bwc__row--ctrl">' +
              '<div class="bwc__qty"><button type="button" data-bwc-qty="-1" aria-label="Decrease quantity">&minus;</button>' +
              '<input type="number" min="0" inputmode="numeric" value="' + it.quantity + '" data-bwc-input aria-label="Quantity">' +
              '<button type="button" data-bwc-qty="1" aria-label="Increase quantity">+</button></div>' +
              '<button type="button" class="bwc__remove" data-bwc-remove>' + esc(this.L.remove || 'Remove') + '</button>' +
            '</div>' +
            '<p class="bwc__err" data-bwc-err role="alert"></p>' +
          '</div></div>';
      }
      render() {
        const c = this.cart;
        if (!c) return;
        const fmt = this.cfg.moneyFormat;
        const empty = !c.items || !c.items.length;
        if (this.countEl) this.countEl.textContent = c.item_count;
        this.itemsEl.innerHTML = empty ? '' : c.items.map((it, i) => this.lineHTML(it, i)).join('');
        this.emptyEl.hidden = !empty;
        if (this.footEl) this.footEl.hidden = empty;
        if (this.totalEl) this.totalEl.innerHTML = BW.money(c.total_price, fmt);
        if (this.saveEl) {
          const saved = (c.original_total_price || 0) - (c.total_price || 0);
          this.saveEl.hidden = saved <= 0;
          if (saved > 0) this.saveEl.innerHTML = '<span>' + BW.esc(this.L.save || 'You save') + '</span><span>' + BW.money(saved, fmt) + '</span>';
        }
        if (this.shipEl) {
          const rate = (window.Shopify && window.Shopify.currency && parseFloat(window.Shopify.currency.rate)) || 1;
          const goal = Math.round((this.cfg.freeThreshold || 0) * rate);
          const left = Math.max(0, goal - c.total_price);
          const done = left === 0;
          this.shipEl.hidden = empty || !goal;
          this.shipEl.classList.toggle('is-done', done);
          const txt = this.shipEl.querySelector('[data-bwc-ship-text]');
          if (txt) txt.innerHTML = done ? BW.esc(this.L.freeDone) : BW.esc(this.L.freeMsg || '').replace('[amount]', '<strong>' + BW.money(left, fmt) + '</strong>');
          const bar = this.shipEl.querySelector('[data-bwc-ship-bar]');
          if (bar) requestAnimationFrame(() => bar.style.setProperty('--p', goal ? Math.min(1, c.total_price / goal) : 0));
        }
        if (empty && this.recsEl) this.recsEl.hidden = true;
        this.updateBubble(c.item_count);
      }
      updateBubble(n) {
        document.querySelectorAll('#cart-icon-bubble').forEach((link) => {
          let b = link.querySelector('.cart-count-bubble');
          if (!n) { if (b) b.remove(); return; }
          const prev = b ? b.textContent : '';
          if (!b) { b = document.createElement('div'); b.className = 'cart-count-bubble'; link.appendChild(b); }
          b.innerHTML = (n < 100 ? '<span aria-hidden="true">' + n + '</span>' : '') + '<span class="visually-hidden">' + n + ' items</span>';
          if (prev && prev.indexOf(String(n)) !== 0) { b.classList.remove('is-bump'); void b.offsetWidth; b.classList.add('is-bump'); }
        });
      }
      async loadRecs() {
        if (!this.recsEl || !this.cfg.cartRecs || !this.cart || !this.cart.items.length) return;
        const pid = this.cart.items[0].product_id;
        try {
          if (this.recsFor !== pid) {
            this.recsFor = pid;
            const res = await fetch(BW.root() + 'recommendations/products.json?product_id=' + pid + '&limit=10&intent=related');
            const data = await res.json();
            this.recs = data.products || [];
          }
        } catch (e) { this.recs = []; }
        const inCart = new Set(this.cart.items.map((x) => x.product_id));
        const list = (this.recs || []).filter((p) => !inCart.has(p.id) && p.available).slice(0, 6);
        this.recsEl.hidden = !list.length;
        if (!list.length) return;
        const track = this.recsEl.querySelector('[data-bwc-recs-track]');
        track.innerHTML = list.map((p, n) => {
          const img = p.featured_image || (p.images && p.images[0]) || '';
          const one = p.variants && p.variants.length === 1;
          return BW.card({
            title: p.title, url: p.url, image: typeof img === 'string' ? img : img.src,
            price: p.price, compare: p.compare_at_price, available: p.available,
            variantId: one ? p.variants[0].id : null, withAdd: true, i: n
          }, this.L, this.cfg.moneyFormat);
        }).join('');
      }
    }
    customElements.define('bw-cart-drawer', BWCartDrawer);
  }

  /* ---------- Bridge so Dawn product forms add to this drawer ---------- */
  (function () {
    const defineProxy = () => {
      if (customElements.get('cart-notification') || !document.querySelector('cart-notification.bwc-proxy')) return;
      class BWCartProxy extends HTMLElement {
        getSectionsToRender() { return []; }
        setActiveElement(el) { this.activeElement = el; }
        renderContents() {
          const d = window.BWCart;
          if (d) d.refresh().then(() => d.open(this.activeElement));
        }
        open() { if (window.BWCart) window.BWCart.open(); }
      }
      customElements.define('cart-notification', BWCartProxy);
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', defineProxy);
    else defineProxy();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["premium-banner-slider"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('premium-banner')) return;

    class PremiumBanner extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        this._ready = true;

        const d = this.dataset;
        this.viewport = this.querySelector('.pb__viewport');
        this.slides = Array.from(this.querySelectorAll('.pb__slide'));
        this.count = this.slides.length;
        this.index = Math.max(0, this.slides.findIndex((s) => s.classList.contains('is-active')));
        this.mode = d.transition === 'fade' ? 'fade' : 'slide';
        this.speed = parseInt(d.speed, 10) || 800;
        this.loop = d.loop === 'true';
        this.adapt = d.height === 'adapt';
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.autoplay = d.autoplay === 'true' && this.count > 1 && !this.reduced;
        this.dots = Array.from(this.querySelectorAll('[data-dot]'));
        this.currentEl = this.querySelector('[data-current]');
        this.timer = this.querySelector('.pb__timer');
        this.prevBtn = this.querySelector('[data-prev]');
        this.nextBtn = this.querySelector('[data-next]');
        this.pauseBtn = this.querySelector('[data-pause]');
        this.reasons = new Set();
        this.busy = false;

        if (this.autoplay) this.classList.add('has-autoplay');

        this.updateHeight = this.updateHeight.bind(this);
        if (this.adapt && 'ResizeObserver' in window) {
          this.ro = new ResizeObserver(this.updateHeight);
          this.slides.forEach((s) => this.ro.observe(s));
        }

        this.render();
        if (this.count < 2) return;

        this.prevBtn && this.prevBtn.addEventListener('click', () => this.prev());
        this.nextBtn && this.nextBtn.addEventListener('click', () => this.next());
        this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.goTo(i)));
        this.pauseBtn && this.pauseBtn.addEventListener('click', () => this.toggleUserPause());
        this.timer && this.timer.addEventListener('animationend', () => this.next(true));

        this.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowLeft') this.prev();
          else if (e.key === 'ArrowRight') this.next();
        });

        if (d.pauseHover === 'true') {
          this.addEventListener('mouseenter', () => this.pause('hover'));
          this.addEventListener('mouseleave', () => this.resume('hover'));
        }
        this.addEventListener('focusin', () => this.pause('focus'));
        this.addEventListener('focusout', (e) => {
          if (!this.contains(e.relatedTarget)) this.resume('focus');
        });

        if ('IntersectionObserver' in window) {
          this.io = new IntersectionObserver(
            (entries) => entries.forEach((en) => (en.isIntersecting ? this.resume('offscreen') : this.pause('offscreen'))),
            { threshold: 0.2 }
          );
          this.io.observe(this);
        }

        this._onVis = () => (document.hidden ? this.pause('hidden') : this.resume('hidden'));
        document.addEventListener('visibilitychange', this._onVis);

        this.addEventListener('shopify:block:select', (e) => {
          const i = this.slides.indexOf(e.target);
          if (i > -1) {
            this.pause('editor');
            this.jump(i);
          }
        });
        this.addEventListener('shopify:block:deselect', () => this.resume('editor'));

        this.initDrag();
      }

      disconnectedCallback() {
        this.ro && this.ro.disconnect();
        this.io && this.io.disconnect();
        this._onVis && document.removeEventListener('visibilitychange', this._onVis);
        clearTimeout(this._t);
      }

      wrap(i) {
        return (i + this.count) % this.count;
      }

      next(auto) {
        const t = this.index + 1;
        if (t >= this.count && !this.loop && !auto) return;
        this.goTo(this.wrap(t), 1);
      }

      prev() {
        const t = this.index - 1;
        if (t < 0 && !this.loop) return;
        this.goTo(this.wrap(t), -1);
      }

      goTo(target, dir, fromDrag) {
        if (target === this.index || this.busy || target < 0 || target >= this.count) return;
        if (!dir) dir = target > this.index ? 1 : -1;
        const cur = this.slides[this.index];
        const nxt = this.slides[target];
        this.busy = true;

        if (this.mode === 'slide' && !this.reduced) {
          if (!fromDrag) {
            nxt.style.transition = 'none';
            nxt.style.transform = 'translate3d(' + dir * 100 + '%,0,0)';
            nxt.classList.add('is-peek');
            void nxt.offsetWidth;
          }
          cur.style.transition = '';
          nxt.style.transition = '';
          cur.style.transform = 'translate3d(' + -dir * 100 + '%,0,0)';
          nxt.style.transform = 'translate3d(0,0,0)';
        }

        cur.classList.add('is-leaving');
        this.index = target;
        this.render();

        clearTimeout(this._t);
        this._t = setTimeout(() => {
          this.cleanup();
          this.busy = false;
        }, this.reduced ? 0 : this.speed);
      }

      jump(i) {
        clearTimeout(this._t);
        this.index = i;
        this.busy = false;
        this.cleanup();
        this.render();
      }

      cleanup() {
        this.slides.forEach((s) => {
          s.classList.remove('is-leaving', 'is-peek');
          s.style.transition = 'none';
          s.style.transform = '';
        });
      }

      render() {
        this.slides.forEach((s, i) => {
          const on = i === this.index;
          s.classList.toggle('is-active', on);
          s.setAttribute('aria-hidden', on ? 'false' : 'true');
          s.inert = !on;
        });
        this.dots.forEach((dot, i) => dot.setAttribute('aria-current', i === this.index ? 'true' : 'false'));
        if (this.currentEl) this.currentEl.textContent = String(this.index + 1).padStart(2, '0');
        if (!this.loop) {
          if (this.prevBtn) this.prevBtn.disabled = this.index === 0;
          if (this.nextBtn) this.nextBtn.disabled = this.index === this.count - 1;
        }
        this.restartProgress();
        this.updateHeight();
      }

      restartProgress() {
        if (!this.autoplay) return;
        const fills = this.dots.map((d) => d.querySelector('.pb__dot-fill')).filter(Boolean);
        [this.timer].concat(fills).forEach((el) => el && el.classList.remove('is-running'));
        void this.offsetWidth;
        this.timer && this.timer.classList.add('is-running');
        const f = this.dots[this.index] && this.dots[this.index].querySelector('.pb__dot-fill');
        f && f.classList.add('is-running');
      }

      updateHeight() {
        if (!this.adapt || !this.slides[this.index]) return;
        const h = this.slides[this.index].offsetHeight;
        if (h) this.viewport.style.height = h + 'px';
      }

      pause(reason) {
        this.reasons.add(reason);
        this.classList.add('is-paused');
      }

      resume(reason) {
        this.reasons.delete(reason);
        if (!this.reasons.size) this.classList.remove('is-paused');
      }

      toggleUserPause() {
        if (this.reasons.has('user')) {
          this.resume('user');
          this.pauseBtn.classList.remove('is-play');
          this.pauseBtn.setAttribute('aria-label', 'Pause slideshow');
        } else {
          this.pause('user');
          this.pauseBtn.classList.add('is-play');
          this.pauseBtn.setAttribute('aria-label', 'Play slideshow');
        }
      }

      initDrag() {
        const vp = this.viewport;
        let st = null;

        vp.addEventListener('dragstart', (e) => e.preventDefault());

        vp.addEventListener('pointerdown', (e) => {
          if (this.busy || (e.pointerType === 'mouse' && e.button !== 0)) return;
          st = { x: e.clientX, y: e.clientY, dx: 0, on: false, id: e.pointerId, peek: null };
        });

        vp.addEventListener('pointermove', (e) => {
          if (!st || e.pointerId !== st.id) return;
          const dx = e.clientX - st.x;
          const dy = e.clientY - st.y;

          if (!st.on) {
            if (Math.abs(dx) > 8 && Math.abs(dx) > Math.abs(dy)) {
              st.on = true;
              try { vp.setPointerCapture(e.pointerId); } catch (err) {}
              this.pause('drag');
              this.classList.add('is-dragging');
              st.w = vp.clientWidth;
              st.prev = this.index > 0 || this.loop ? this.wrap(this.index - 1) : null;
              st.next = this.index < this.count - 1 || this.loop ? this.wrap(this.index + 1) : null;
            } else if (Math.abs(dy) > 8) {
              st = null;
              return;
            } else {
              return;
            }
          }

          st.dx = dx;
          if (this.mode !== 'slide' || this.reduced) return;

          const goingNext = dx < 0;
          const n = goingNext ? st.next : st.prev;
          const x = n === null ? dx * 0.25 : dx;
          const cur = this.slides[this.index];
          cur.style.transition = 'none';
          cur.style.transform = 'translate3d(' + x + 'px,0,0)';

          if (st.peek !== null && st.peek !== n) {
            const p = this.slides[st.peek];
            p.classList.remove('is-peek');
            p.style.transform = '';
          }
          if (n !== null) {
            const el = this.slides[n];
            el.style.transition = 'none';
            el.classList.add('is-peek');
            el.style.transform = 'translate3d(calc(' + (goingNext ? 100 : -100) + '% + ' + x + 'px),0,0)';
            st.peek = n;
          } else {
            st.peek = null;
          }
        });

        const end = () => {
          if (!st) return;
          const s = st;
          st = null;
          if (!s.on) return;

          this.classList.remove('is-dragging');
          this.dragged = true;
          setTimeout(() => (this.dragged = false), 60);

          const th = Math.min(90, s.w * 0.15);
          if (s.dx < -th && s.next !== null) {
            this.goTo(s.next, 1, true);
          } else if (s.dx > th && s.prev !== null) {
            this.goTo(s.prev, -1, true);
          } else if (this.mode === 'slide' && !this.reduced) {
            const cur = this.slides[this.index];
            cur.style.transition = '';
            cur.style.transform = 'translate3d(0,0,0)';
            if (s.peek !== null) {
              const p = this.slides[s.peek];
              p.style.transition = '';
              p.style.transform = 'translate3d(' + (s.dx < 0 ? 100 : -100) + '%,0,0)';
            }
            this.busy = true;
            clearTimeout(this._t);
            this._t = setTimeout(() => {
              this.cleanup();
              this.busy = false;
            }, this.speed);
          }
          this.resume('drag');
        };

        vp.addEventListener('pointerup', end);
        vp.addEventListener('pointercancel', end);

        this.addEventListener(
          'click',
          (e) => {
            if (this.dragged) {
              e.preventDefault();
              e.stopPropagation();
            }
          },
          true
        );
      }
    }

    customElements.define('premium-banner', PremiumBanner);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial-section"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('bw-testimonials')) return;

    class BWTestimonials extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        if (!this.track) return;
        this.slides = Array.from(this.track.querySelectorAll('.bwt__slide'));
        this.prev = this.querySelector('[data-dir="prev"]');
        this.next = this.querySelector('[data-dir="next"]');
        this.current = this.querySelector('[data-current]');
        this.bar = this.querySelector('[data-progress]');
        this.dialog = this.querySelector('.bwt__lightbox');
        this.index = 0;

        this.addEventListener('click', this.onClick.bind(this));
        this.track.addEventListener('scroll', () => {
          cancelAnimationFrame(this.raf);
          this.raf = requestAnimationFrame(() => this.update());
        }, { passive: true });
        this.track.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowRight') { e.preventDefault(); this.go(this.index + 1); }
          if (e.key === 'ArrowLeft') { e.preventDefault(); this.go(this.index - 1); }
        });

        if (window.ResizeObserver) {
          this.ro = new ResizeObserver(() => this.update());
          this.ro.observe(this.track);
        }

        if (this.dialog) {
          this.dialog.addEventListener('click', (e) => { if (e.target === this.dialog) this.dialog.close(); });
          this.dialog.addEventListener('close', () => document.documentElement.style.removeProperty('overflow'));
        }

        this.setupAutoplay();
        this.update();

        this.onBlockSelect = (e) => {
          var slide = e.target.closest && e.target.closest('.bwt__slide');
          if (!slide || !this.contains(slide)) return;
          this.stopAutoplay();
          this.go(this.slides.indexOf(slide));
        };
        document.addEventListener('shopify:block:select', this.onBlockSelect);
      }

      disconnectedCallback() {
        this.stopAutoplay();
        if (this.ro) this.ro.disconnect();
        if (this.io) this.io.disconnect();
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
      }

      onClick(e) {
        var arrow = e.target.closest('[data-dir]');
        if (arrow) { this.userInteracted(); this.go(this.index + (arrow.dataset.dir === 'next' ? 1 : -1)); return; }

        var play = e.target.closest('[data-play]');
        if (play) { this.playVideo(play.closest('[data-video]')); return; }

        var playEmbed = e.target.closest('[data-play-embed]');
        if (playEmbed) { this.playEmbed(playEmbed.closest('[data-embed]')); return; }

        var zoom = e.target.closest('[data-lightbox]');
        if (zoom) { this.openLightbox(zoom); return; }

        if (e.target.closest('[data-close]') && this.dialog) this.dialog.close();
      }

      /* ---------- Slider ---------- */
      go(i) {
        if (!this.slides.length) return;
        var max = this.slides.length - 1;
        i = Math.max(0, Math.min(max, i));
        var slide = this.slides[i];
        var offset = slide.offsetLeft - this.track.firstElementChild.offsetLeft;
        this.track.scrollTo({ left: offset, behavior: this.reduced() ? 'auto' : 'smooth' });
        this.index = i;
        this.render();
      }

      update() {
        var trackLeft = this.track.getBoundingClientRect().left;
        var styles = getComputedStyle(this.track);
        var pad = parseFloat(styles.paddingLeft) || 0;
        var best = 0;
        var min = Infinity;
        this.slides.forEach((slide, i) => {
          var d = Math.abs(slide.getBoundingClientRect().left - trackLeft - pad);
          if (d < min) { min = d; best = i; }
        });
        var maxScroll = this.track.scrollWidth - this.track.clientWidth;
        if (maxScroll > 0 && this.track.scrollLeft >= maxScroll - 2) best = this.slides.length - 1;
        this.index = best;
        this.render();
      }

      render() {
        var total = this.slides.length;
        var maxScroll = this.track.scrollWidth - this.track.clientWidth;
        var atStart = this.track.scrollLeft <= 2;
        var atEnd = maxScroll <= 2 || this.track.scrollLeft >= maxScroll - 2;
        if (this.prev) this.prev.disabled = atStart;
        if (this.next) this.next.disabled = atEnd;
        if (this.current) this.current.textContent = String(this.index + 1).padStart(2, '0');
        if (this.bar && total) {
          var width = Math.max(100 / total, 8);
          var progress = maxScroll > 0 ? this.track.scrollLeft / maxScroll : 0;
          this.bar.style.width = width + '%';
          this.bar.style.left = (progress * (100 - width)) + '%';
        }
        this.slides.forEach((s, i) => {
          if (i !== this.index) {
            var v = s.querySelector('video');
            if (v && !v.paused) v.pause();
          }
        });
      }

      reduced() { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; }

      /* ---------- Autoplay ---------- */
      setupAutoplay() {
        this.delay = (parseInt(this.dataset.autoplay, 10) || 0) * 1000;
        if (!this.delay || this.slides.length < 2 || this.reduced() || (window.Shopify && window.Shopify.designMode)) return;
        this.hovering = false;
        this.visible = false;
        ['mouseenter', 'focusin', 'touchstart'].forEach((ev) => this.addEventListener(ev, () => { this.hovering = true; }, { passive: true }));
        ['mouseleave', 'focusout'].forEach((ev) => this.addEventListener(ev, () => { this.hovering = false; }));
        if ('IntersectionObserver' in window) {
          this.io = new IntersectionObserver((entries) => { this.visible = entries[0].isIntersecting; }, { threshold: 0.3 });
          this.io.observe(this);
        } else {
          this.visible = true;
        }
        this.timer = setInterval(() => {
          if (this.hovering || !this.visible || this.playing) return;
          var maxScroll = this.track.scrollWidth - this.track.clientWidth;
          if (this.track.scrollLeft >= maxScroll - 2) this.go(0);
          else this.go(this.index + 1);
        }, this.delay);
      }

      stopAutoplay() { if (this.timer) clearInterval(this.timer); this.timer = null; }
      userInteracted() { this.stopAutoplay(); }

      /* ---------- Media ---------- */
      playVideo(wrap) {
        if (!wrap) return;
        var video = wrap.querySelector('video');
        if (!video) return;
        this.userInteracted();
        this.pauseOthers(video);
        wrap.classList.add('is-playing');
        video.controls = true;
        video.play().catch(() => {});
        this.playing = true;
        video.addEventListener('pause', () => { this.playing = false; }, { once: true });
      }

      playEmbed(wrap) {
        if (!wrap || !wrap.dataset.embed) return;
        this.userInteracted();
        this.pauseOthers();
        var iframe = document.createElement('iframe');
        iframe.src = wrap.dataset.embed;
        iframe.allow = 'autoplay; fullscreen; picture-in-picture; encrypted-media';
        iframe.allowFullscreen = true;
        iframe.title = 'Customer video';
        wrap.classList.add('is-playing');
        wrap.innerHTML = '';
        wrap.appendChild(iframe);
        this.playing = true;
      }

      pauseOthers(except) {
        this.querySelectorAll('video').forEach((v) => { if (v !== except && !v.paused) v.pause(); });
      }

      openLightbox(btn) {
        if (!this.dialog) return;
        var img = this.dialog.querySelector('[data-lightbox-img]');
        var cap = this.dialog.querySelector('[data-lightbox-caption]');
        var thumb = btn.querySelector('img');
        img.src = btn.dataset.lightbox;
        img.alt = thumb ? thumb.alt : '';
        cap.textContent = btn.dataset.caption || '';
        cap.hidden = !btn.dataset.caption;
        this.userInteracted();
        this.dialog.showModal();
        document.documentElement.style.overflow = 'hidden';
      }
    }

    customElements.define('bw-testimonials', BWTestimonials);
  })();

  } catch(e) { console.error(e); }
})();
})();
